var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-12",
    cx: 249.48,
    cy: 355.18,
    rx: 229.28,
    ry: 134.26,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-12",
    d: "M138.74,431.5,57.05,388c-4.53-2.41-4.59-6.45-.15-9l50.8-29.33c4.45-2.57,11.94-3.18,16.74-1.38l96.8,36.44c4.8,1.8,5.09,5.35.64,7.91L155,431.22C150.54,433.78,143.27,433.91,138.74,431.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-12",
    d: "M176.27,446.68C156,435,156,416,176.27,404.28s53.17-11.71,73.45,0,20.29,30.69,0,42.4S196.56,458.39,176.27,446.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-12",
    d: "M310.89,384.91,229.2,341.38c-4.53-2.41-4.59-6.45-.15-9L279.85,303c4.45-2.57,11.94-3.18,16.74-1.38l96.8,36.44c4.8,1.8,5.09,5.35.64,7.91l-66.9,38.63C322.69,387.2,315.42,387.33,310.89,384.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-12",
    d: "M351.66,404.61c-24.6-14.2-24.6-37.22,0-51.42s64.46-14.2,89,0,24.6,37.22,0,51.42S376.25,418.81,351.66,404.61Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.93,352.93c-2.13-15-3.64-28.84,1.22-51.14,4.07-18.71,18.15-38.87,29.32-39.54,10.41-.62,14.34,11.76,6.51,24.24s-25.26,36.68-24.51,52.4l-1.67,18.19Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,352.93c-2.13-15-3.64-28.84,1.22-51.14,4.07-18.71,18.15-38.87,29.32-39.54,10.41-.62,14.34,11.76,6.51,24.24s-25.26,36.68-24.51,52.4l-1.67,18.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.35,347a.65.65,0,0,0,.43-.68c-3-34.66,15.08-65.15,28.09-74.66a.67.67,0,0,0-.79-1.08c-13.26,9.69-31.63,41.17-28.63,75.85a.68.68,0,0,0,.72.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,358.74c0-5.35,3.58-15.26,11.33-24.85,8.58-10.61,21.2-18.05,22.63-24.76,1.72-8.07-5.63-11.3-16.59-7.44-13.17,4.65-26.2,22.1-24.63,54.1Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.22,354.2a.67.67,0,0,0,.42-.59c1.61-28.35,18.52-43.12,27.23-47a.67.67,0,0,0-.54-1.23c-9.63,4.26-26.38,19.19-28,48.12a.67.67,0,0,0,.63.71A.66.66,0,0,0,428.22,354.2Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.36,344.5l-11.19-84.66-9.25-.47,15.78,85.11h0a1.24,1.24,0,0,0,.62.83,3.64,3.64,0,0,0,3.29.17,1.13,1.13,0,0,0,.73-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.17,259.84l-9.25-.47,3.28,17.69a28.44,28.44,0,0,0,5.67-2.74,4.72,4.72,0,0,0,2-1.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29,250.81H249L235.57,336.5h0a1.13,1.13,0,0,0,.67,1,3.69,3.69,0,0,0,3.3,0,1.26,1.26,0,0,0,.66-.8h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,250.81l-3.88,24.67a36.19,36.19,0,0,0,7,4.42l6.14-29.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.49,376.16l-8.58-86.25-9.24-.47,13.16,86.7h0a1.24,1.24,0,0,0,.62.83,3.66,3.66,0,0,0,3.3.17,1.14,1.14,0,0,0,.72-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.31,304l-1.4-14.07-9.24-.47,2.3,15.15C310,305.22,313.62,304.85,316.31,304Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.82,221.42h-9.25L286.1,307.11h0a1.1,1.1,0,0,0,.67,1,3.62,3.62,0,0,0,3.3,0,1.26,1.26,0,0,0,.66-.79h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,223.9a9,9,0,0,0-1.25-.14l-11.75,74.53c1.69.91,2.92,1.59,4.61,2.46l16-75.25C305.57,224.92,303.05,224.38,300.49,223.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.17,255.37c0-2.92-2.57-6-8-9.54-10-6.49-39.1-22.73-53.09-30.48a.14.14,0,0,0-.12-.12c-10.76-6.53-14-34.42-21.49-58.06-.16-.5-.31-1-.48-1.47l-.39-1.1c-.47-1.29-.95-2.46-1.46-3.54-.12-.25-.23-.49-.35-.72a25.14,25.14,0,0,0-1.55-2.76q-.21-.33-.42-.63c-.26-.39-.53-.75-.8-1.09l-.47-.55a10,10,0,0,0-.76-.82c-.21-.22-.42-.42-.64-.61a12.26,12.26,0,0,0-2-1.47l-.51-.29a.11.11,0,0,0-.07,0l-.13-.08-.23-.13L283,140.63l-.6-.33-.27-.16-.79-.45a10.56,10.56,0,0,0-2.16-1l-.75-.23c-.28-.07-.56-.13-.86-.18a17.88,17.88,0,0,0-8.57.92,6.69,6.69,0,0,0-.68.22c-.67.24-1.36.49-2.05.76h0c-.92.38-1.87.8-2.84,1.24-3.39,1.56-7.05,3.56-10.94,5.69l-1.38.78c-.56.31-1.1.64-1.65,1l-1,.65c-.86.56-1.71,1.13-2.54,1.75l-1.23.94c-.39.33-.79.65-1.18,1-.59.5-1.15,1-1.7,1.59-.37.35-.73.73-1.07,1.12a26.93,26.93,0,0,0-2,2.45l0,0-.46.64c-.32.46-.63.93-.93,1.42-.44.7-.86,1.43-1.26,2.2-.13.26-.27.52-.39.78s-.27.54-.39.81-.24.55-.37.84a52.5,52.5,0,0,0-3.7,16.25c-1,12.46,0,36.28,2.49,54.33v0c3.66,30.16,8.15,30.21,14.69,35.26,11.24,8.68,36.55,20.88,47.22,25.08,19.35,7.62,35.16-4.13,47-10a274.53,274.53,0,0,0,31.23-18.49c2.94-2.15,4.47-4.32,4.44-6.6C378.15,260,378.17,256.32,378.17,255.37Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,255.37c0-2.92-2.57-6-8-9.54-10-6.49-39.1-22.73-53.09-30.48a.14.14,0,0,0-.12-.12c-10.76-6.53-14-34.42-21.49-58.06-.16-.5-.31-1-.48-1.47l-.39-1.1c-.47-1.29-.95-2.46-1.46-3.54-.12-.25-.23-.49-.35-.72a25.14,25.14,0,0,0-1.55-2.76q-.21-.33-.42-.63c-.26-.39-.53-.75-.8-1.09l-.47-.55a10,10,0,0,0-.76-.82c-.21-.22-.42-.42-.64-.61a12.26,12.26,0,0,0-2-1.47l-.51-.29a.11.11,0,0,0-.07,0l-.13-.08-.23-.13L283,140.63l-.6-.33-.27-.16-.79-.45a10.56,10.56,0,0,0-2.16-1l-.75-.23c-.28-.07-.56-.13-.86-.18a17.88,17.88,0,0,0-8.57.92,6.69,6.69,0,0,0-.68.22c-.67.24-1.36.49-2.05.76h0c-.92.38-1.87.8-2.84,1.24-3.39,1.56-7.05,3.56-10.94,5.69l-1.38.78c-.56.31-1.1.64-1.65,1l-1,.65c-.86.56-1.71,1.13-2.54,1.75l-1.23.94c-.39.33-.79.65-1.18,1-.59.5-1.15,1-1.7,1.59-.37.35-.73.73-1.07,1.12a26.93,26.93,0,0,0-2,2.45l0,0-.46.64c-.32.46-.63.93-.93,1.42-.44.7-.86,1.43-1.26,2.2-.13.26-.27.52-.39.78s-.27.54-.39.81-.24.55-.37.84a52.5,52.5,0,0,0-3.7,16.25c-1,12.46,0,36.28,2.49,54.33v0c3.66,30.16,8.15,30.21,14.69,35.26,11.24,8.68,36.55,20.88,47.22,25.08,19.35,7.62,35.16-4.13,47-10a274.53,274.53,0,0,0,31.23-18.49c2.94-2.15,4.47-4.32,4.44-6.6C378.15,260,378.17,256.32,378.17,255.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.48,280.42a272.32,272.32,0,0,0,31.23-18.51c6.71-4.87,6.09-9.85-3.52-16.08-13.35-8.66-60.77-34.73-60.77-34.73s-68.81,40.61-65.85,48.1,38.54,25.88,52,31.16C314.88,298,330.69,286.24,342.48,280.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.48,280.42a272.32,272.32,0,0,0,31.23-18.51c6.71-4.87,6.09-9.85-3.52-16.08-13.35-8.66-60.77-34.73-60.77-34.73s-68.81,40.61-65.85,48.1,38.54,25.88,52,31.16C314.88,298,330.69,286.24,342.48,280.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.88,290.05c7.41-2.72,14-6.85,19.6-9.63a272.32,272.32,0,0,0,31.23-18.51l.54-.41a15.16,15.16,0,0,0-4-5.81c-8.68-8.35-39.39-30.82-53.29-30.49s-53.2,19.93-57.5,23.28c-7.31,5.71-3.31,12.2,3.91,16.46s30.76,15.89,44.11,20.46C313.88,287.58,318.73,289.06,322.88,290.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.73,142.16c-7.24-3.8-16.65,1.37-28.3,7.75-7.46,4.09-13.81,8.93-17.67,18l-4.92-2.84c3.86-9,10.21-13.88,17.64-17.95,12-6.55,21.55-11.8,28.86-7.43Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.73,142.16c-7.24-3.8-16.65,1.37-28.3,7.75-7.46,4.09-13.81,8.93-17.67,18l-4.92-2.84c3.86-9,10.21-13.88,17.64-17.95,12-6.55,21.55-11.8,28.86-7.43Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.49,157.17c-.16-.5-.31-1-.48-1.47l-.39-1.1c-.47-1.29-.95-2.46-1.46-3.54-.12-.25-.23-.49-.35-.72a25.14,25.14,0,0,0-1.55-2.76q-.21-.33-.42-.63c-.26-.39-.53-.75-.8-1.09l-.47-.55a10,10,0,0,0-.76-.82c-.21-.22-.42-.42-.64-.61a11.7,11.7,0,0,0-1.05-.84c-.23-.17-.46-.31-.7-.46l-.26-.17-.51-.29a.11.11,0,0,0-.07,0l-.13-.08-.37-.16c-.18-.09-.35-.16-.53-.23a11.69,11.69,0,0,0-2.16-.58l-.58-.08c-.28,0-.56-.07-.84-.08l-.72,0c-6.32,0-13.92,4.18-22.82,9-.74.41-1.47.83-2.2,1.26-.28.15-.55.32-.82.49s-.66.41-1,.62-.48.3-.72.47a42.55,42.55,0,0,0-4.48,3.4c-.23.2-.45.4-.67.62a30.35,30.35,0,0,0-2.55,2.64l-.43.5-.5.63c-.17.21-.33.43-.49.65s-.32.43-.48.66c-.62.9-1.22,1.84-1.78,2.85l-.21.38c-.14.26-.28.53-.41.8s-.39.8-.58,1.2a51.22,51.22,0,0,0-4,17c-1.73,20.47,2.07,71.59,9.11,77.43,0,0-1.08-6.62,13.08-15.54,9.63-6,16.38-11.14,26.65-16.18,25-12.29,32.05-14.6,32.05-14.6C306.22,208.7,303,180.81,295.49,157.17Z",
    style: {
      fill: "#D175F7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.58,331.33l6.56,30.19c3,7.11,7.23,12.27,13,18.52,1.25,1.37,4.09,3.88,5.11,5a2.19,2.19,0,0,1-.13,3.38c-2.4,2.44-12.85,3.32-18.86-.91S362.61,374.06,359,370.62c-1.36-1.29-2.64-2.61-3.86-4s-.91-2.69-1.05-4.25c-.08-.75,0-2.81,0-2.81-.91-3.66-3.26-9.38-4.53-12.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,376.13a8.06,8.06,0,0,0,.35,2.66c.63,1.41,6,4.35,8.09,5.38s4.29,2.48,6.22,6.68c2.06,4.48,6.15,7.72,10.83,9.89a33.87,33.87,0,0,0,20,2.18c8.38-1.47,9.08-6.4,9.08-6.4s.47-4.64-1.61-5.38S352.49,376.13,352.49,376.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.73,358.4c-.23.11-.65.24-.87,1.22-.08.36.26,4.3,0,6.57-.24,2.42-1.44,7-.4,9.94,4.42,4.52,11.36,5.69,14.7,10.37s6.43,10.53,17.38,12.76,19.3-1.21,21.34-4.32.2-6.06-6.8-9.89c-7.44-4.06-17.2-16.11-17.2-16.12a49.43,49.43,0,0,1-3.69-5.36c-1.09-1.78-1.55-4-2.36-6a4.74,4.74,0,0,0-1.67-2.39,4.84,4.84,0,0,0-2.9-.39,21.24,21.24,0,0,0-4.7.68,7.22,7.22,0,0,0-3.87,2.6,31,31,0,0,1-1.74,3,4.14,4.14,0,0,1-4.17,1.27,3.56,3.56,0,0,1-2.83-3A9.58,9.58,0,0,1,353.73,358.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,396.61s-.11-7.68,8.18-11.86,13.3-1.44,15.82.4c3,2.18,7.29,6.73,4.66,10-2.85,3.54-7.38,5.21-15.82,5.26S377.48,396.61,377.48,396.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.29,370.92a1,1,0,0,0,.75-.39c.95-1.3,7-6.16,12.79-4.52.3-.67-.18-1.36-1.38-2.08-6.1-.58-11.83,4-13,5.56a.89.89,0,0,0,.24,1.27A1,1,0,0,0,366.29,370.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.14,370.4a2.85,2.85,0,0,0-1.64-2c-5.8-.15-11.12,4.12-12.22,5.62a.89.89,0,0,0,.24,1.27,1,1,0,0,0,.57.16,1,1,0,0,0,.76-.39C371.76,373.77,377.5,369.16,383.14,370.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.21,379.86a5.24,5.24,0,0,0-2.58-2.45c-6-.43-11.61,4-12.74,5.59a.88.88,0,0,0,.24,1.26.94.94,0,0,0,.57.16,1,1,0,0,0,.76-.39C379.46,382.66,386.13,377.33,392.21,379.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.9,379.92a1,1,0,0,0,.75-.39c.94-1.29,6.86-6,12.6-4.56a3.27,3.27,0,0,0-1.94-2.1c-5.81-.15-11.13,4.12-12.22,5.63a.88.88,0,0,0,.24,1.26A1,1,0,0,0,373.9,379.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.88,316.91s3.11,20,6.59,26.59c3.63,6.83,3.35,10,8.8,16.5,1.18,1.42,3.89,4.07,4.86,5.22a2.18,2.18,0,0,1-.29,3.37c-2.51,2.32-10.52-.21-16.31-4.71s-17-15.81-18.13-17.27a10.6,10.6,0,0,1-1.87-5.18,16.82,16.82,0,0,1-.13-3.19c-.78-3.45-3.61-9.2-5.09-13.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,356a7.89,7.89,0,0,0,.54,2.63c.72,1.36,6.32,3.92,8.44,4.8s4.45,2.18,6.67,6.23c2.37,4.32,6.68,7.27,11.5,9.11a33.86,33.86,0,0,0,20.11.77c8.26-2.05,8.62-7,8.62-7s.13-4.67-2-5.26S391.41,356,391.41,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,338.24c-.21.12-.62.28-.77,1.27-.06.37.55,4.27.49,6.55-.07,2.44-1,7.07.29,9.95,4.72,4.2,11.73,4.88,15.39,9.32S414,375.38,425,376.84s19.16-2.55,21-5.8-.21-6.06-7.47-9.39c-7.71-3.53-18.28-14.87-18.29-14.88a50,50,0,0,1-4.05-5.09c-1.21-1.7-1.83-3.91-2.77-5.78a4.71,4.71,0,0,0-1.84-2.27,5,5,0,0,0-2.92-.19,21.39,21.39,0,0,0-4.63,1,7.14,7.14,0,0,0-3.68,2.86c-.59,1-.85,2.15-1.53,3.07a4.14,4.14,0,0,1-4.08,1.56,3.57,3.57,0,0,1-3-2.79A9.17,9.17,0,0,1,391.4,338.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77,374.69s-.64-7.65,7.33-12.4,13.17-2.36,15.81-.71c3.15,2,7.74,6.21,5.35,9.66-2.59,3.72-7,5.7-15.41,6.35S417.77,374.69,417.77,374.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,349.85a1,1,0,0,0,.72-.44c.86-1.37,6.54-6.64,12.45-5.4.25-.69-.28-1.35-1.52-2-6.13-.15-11.53,4.81-12.56,6.46a.88.88,0,0,0,.33,1.24A.92.92,0,0,0,404.81,349.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.58,348.15a2.86,2.86,0,0,0-1.77-1.91c-5.8.26-10.81,4.88-11.8,6.46a.89.89,0,0,0,.33,1.25,1,1,0,0,0,.58.12,1,1,0,0,0,.72-.44C410.47,352.3,415.87,347.31,421.58,348.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.29,357a5.26,5.26,0,0,0-2.75-2.27c-6,0-11.29,4.84-12.3,6.46a.89.89,0,0,0,.32,1.25,1,1,0,0,0,.58.12,1,1,0,0,0,.73-.44C418.77,360.64,425.05,354.85,431.29,357Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,358.29a.94.94,0,0,0,.73-.44c.84-1.35,6.41-6.5,12.24-5.43a3.22,3.22,0,0,0-2.08-1.95c-5.8.25-10.81,4.88-11.8,6.46a.88.88,0,0,0,.33,1.24A.93.93,0,0,0,413,358.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.4,257.58c-1.61-7.65-6.93-13-14.23-16.92-23.47-12.54-57.82-28-57.82-28h0l-60.33-5c-6.31,15.8-8.42,31.39-4.72,39.55,5,11.13,11.81,15.34,28.19,23.92,13.54,7.1,35.58,15,39.54,16.78,3,1.31,4.42,3.92,6,11.5,1.63,7.95,1.95,14.2,10.36,30.73,8.24,16.18,9.93,19.68,9.93,19.68s13.72.34,21.45-6.9c0,0-12.34-60.39-16.13-70.07a18.31,18.31,0,0,0-4.12-5.4c5.19,1.68,9,2.92,10.42,3.36,3.1,1,5,1.27,6.16,8.92,1.33,8.67,2.27,12.32,9.86,28.15,7.85,16.38,9.41,20.5,9.41,20.5s13.26.63,21.33-6.24C408.68,322.12,395.55,267.76,393.4,257.58Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.4,257.58c-1.61-7.65-6.93-13-14.23-16.92-23.47-12.54-57.82-28-57.82-28h0l-60.33-5c-6.31,15.8-8.42,31.39-4.72,39.55,5,11.13,11.81,15.34,28.19,23.92,13.54,7.1,35.58,15,39.54,16.78,3,1.31,4.42,3.92,6,11.5,1.63,7.95,1.95,14.2,10.36,30.73,8.24,16.18,9.93,19.68,9.93,19.68s13.72.34,21.45-6.9c0,0-12.34-60.39-16.13-70.07a18.31,18.31,0,0,0-4.12-5.4c5.19,1.68,9,2.92,10.42,3.36,3.1,1,5,1.27,6.16,8.92,1.33,8.67,2.27,12.32,9.86,28.15,7.85,16.38,9.41,20.5,9.41,20.5s13.26.63,21.33-6.24C408.68,322.12,395.55,267.76,393.4,257.58Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.42,267.34c-11.75-9.23-40.6-28.87-40.6-28.87h0c6.54-4,9.85-13.49,9.85-13.49a25.5,25.5,0,0,1-3.64,13c3,2.44,23.5,17.87,28.46,22.78A44.8,44.8,0,0,1,351.42,267.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.31,132.59c12.36,2.29,15,3.83,19.87,22.63,4.27,16.62,9.78,39.2,9.78,39.2s25.45,13,30.46,15.93c2,1.14,7.09,2.59,9.83,5.55,4.25,4.61,14.5,16.49,14.5,16.49s-19.3-5.17-32.35-9.32c0,0-28.9-12.49-31.75-13.9-7.19-3.57-9.82-5-12.08-16.24s-8.45-36.25-8.45-36.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,132.72c4.08.43,9.47,1.58,12.73,6.13s4.84,11.37,7.2,20.48,5.62,22,5.62,22-10.8,7.9-24.48,4.35l-6.46-29.86Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,132.72c4.08.43,9.47,1.58,12.73,6.13s4.84,11.37,7.2,20.48,5.62,22,5.62,22-10.8,7.9-24.48,4.35l-6.46-29.86Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.93,140.49c-.7,5.72-3.72,52.45.83,91.95,18,8.85,63.53,2,67.59-19.83,0,0-5.3-4.13-7.36-15.21.56-15.29.66-29.59.89-36.15.25-7.23,3.15-23.36-9.31-28.53l-20.06-4.36-27.72,6.31S253.37,136.91,252.93,140.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.15,75.37a10.39,10.39,0,0,0-8.4,4.91c-1.94,3.15-1.43,9.9-.34,18.85s2.47,14.44,3.44,17a6.69,6.69,0,0,0,3.47,3.55l1-10.34.5-7.23s6.25,2.74,9.1-7.56c1.8-6.48,1.17-8.71,1.17-8.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.72,87.56a19.39,19.39,0,1,0,21.53-17A19.4,19.4,0,0,0,283.72,87.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.32,101.58c-2,.35-2.55-3.17-3.83-4.86s-5.74-3.67-9.46.39-.94,12.06,2.41,14.14c4.91,3,7.88-1.92,7.88-1.92L274,132.7s.84,4.53,9.38,8.75c6.65,3.29,17.34.43,11.69-7l.81-7.07c2.69.55,6.16,1.09,9.16.19,3.17-1,5.54-2.48,8.52-7.32,5.66-9.21,6.42-23.55,3.87-36.62-4.81-4.74-18.4-3.53-30.37,2.18C285,100.18,281.59,101.19,279.32,101.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,71.39a.93.93,0,0,0-.63-.62,1.14,1.14,0,0,0-.68.21,30.72,30.72,0,0,1-4.56,2.32,15.31,15.31,0,0,0,.77-5.74c-.07-1.19-.07-3.93-1.48-4.4-.84-.27-1.67.35-2.39.88-6.44,4.71-13.69,1.29-20.69.67-5.85-.53-13.17,1-16.49,6.34-1.52,2.45-2.06,5.16.1,7.24,1.85,1.78,7.84,6.54,10.16,7.54,6.14,2.65,22.51,6.93,32.4-2.86a17,17,0,0,0,3.64-6.72,8.57,8.57,0,0,0-.13-4.79A.19.19,0,0,1,323,71.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91,127.4s-8.51-3.26-11.75-6a16.76,16.76,0,0,1-4.84-6.54s.3,5,2.45,7.95c3.77,5.07,13.81,7.36,13.81,7.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.58,102.09a2.14,2.14,0,1,1-1.86-2.46A2.17,2.17,0,0,1,298.58,102.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17,116.79a2.14,2.14,0,1,1-1.86-2.45A2.18,2.18,0,0,1,300.17,116.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,94.92,296,92.29a2.75,2.75,0,0,1-1,3.66A2.56,2.56,0,0,1,291.53,94.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.91,95.9l-4.83-2.06a2.52,2.52,0,0,1,3.36-1.45A2.77,2.77,0,0,1,316.91,95.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.75,102.61a2.13,2.13,0,1,1-1.85-2.46A2.16,2.16,0,0,1,314.75,102.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.12 112.85 311.34 111.25 305.09 98.17 304.12 112.85",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,285.86l-7.41,4.29a5.1,5.1,0,0,1-7.65-4.42V245.64l4.64,2.68v37.41a.41.41,0,0,0,.23.39.39.39,0,0,0,.46,0l4.84-2.79C270.34,284.18,272,285,273.61,285.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.24,297.2l-10.41,6a5,5,0,0,1-5.1,0,5.05,5.05,0,0,1-2.55-4.41V258.71l4.64,2.57V298.8a.42.42,0,0,0,.24.39.41.41,0,0,0,.45,0l7-4,2,.82A36.42,36.42,0,0,0,299.24,297.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.91,234.35l-32.37-18.72c-6.66-3.85-17.46-3.86-24.13,0l-17.36,10c-6.67,3.84-17.47,3.84-24.13,0L276,214.74c-6.67-3.84-17.47-3.84-24.13,0l-6.05,3.5c-3.32,1.91-5,4.42-5,6.93v6.13c0,2.52,1.65,5,5,7l75.45,43.56c6.66,3.85,17.46,3.85,24.12,0l47.55-27.46c3.33-1.92,5-4.44,5-7,0-1,0-5.06,0-6.08C397.9,238.81,396.24,236.28,392.91,234.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,232.17l75.45,43.56c6.66,3.85,17.46,3.86,24.12,0l47.55-27.45c6.66-3.85,6.67-10.09,0-13.94l-32.37-18.72c-6.66-3.85-17.46-3.86-24.13,0l-17.36,10c-6.67,3.84-17.47,3.84-24.13,0L276,214.74c-6.67-3.84-17.47-3.84-24.13,0l-6.05,3.5C239.12,222.08,239.12,228.32,245.78,232.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Exam--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.48,240.79l43.95,25.38a2.75,2.75,0,0,0,2.47,0l32.35-18.68a.76.76,0,0,0,0-1.43L339.3,220.68a2.77,2.77,0,0,0-2.48,0l-32.34,18.68C303.79,239.75,303.79,240.39,304.48,240.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.48,243.82l43.95,25.38a2.75,2.75,0,0,0,2.47,0l32.35-18.68a.76.76,0,0,0,0-1.43L339.3,223.72a2.71,2.71,0,0,0-2.48,0l-32.34,18.67C303.79,242.79,303.79,243.43,304.48,243.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M304.48,242l43.95,25.38a2.75,2.75,0,0,0,2.47,0l32.35-18.68a.76.76,0,0,0,0-1.43L339.3,221.88a2.71,2.71,0,0,0-2.48,0l-32.34,18.67C303.79,241,303.79,241.59,304.48,242Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,265.1l31.59-18.24-43.27-25a2.71,2.71,0,0,0-2.48,0l-31.68,18.29,43.17,24.93A3,3,0,0,0,351,265.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.48,238.59,348.43,264a2.69,2.69,0,0,0,2.47,0l32.35-18.67a.76.76,0,0,0,0-1.43L339.3,218.48a2.77,2.77,0,0,0-2.48,0l-32.34,18.68C303.79,237.55,303.79,238.19,304.48,238.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,245.29a.48.48,0,0,1-.22.05.52.52,0,0,1-.23-.05l-.88-.52a.13.13,0,0,1-.1-.13s0-.09.1-.13l4-2.28a.38.38,0,0,1,.22-.06.41.41,0,0,1,.23.06l5.4,3.11a.16.16,0,0,1,.09.14.14.14,0,0,1-.09.12l-3.9,2.25a.38.38,0,0,1-.22.06.41.41,0,0,1-.23-.06l-.88-.51a.14.14,0,0,1-.1-.13c0-.05,0-.09.1-.13l2.57-1.49-.9-.52-2.39,1.38a.41.41,0,0,1-.23.06.38.38,0,0,1-.22-.06l-.89-.51a.15.15,0,0,1-.09-.13c0-.05,0-.09.09-.13l2.39-1.38-.94-.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.13,247.55l-.43-1.49a.23.23,0,0,1,0-.14s.06-.1.17-.17l1.27-.73a.34.34,0,0,1,.18,0,.38.38,0,0,1,.19,0s0,0,0,0,0,0,0,0l.77,2.67,4.45.44a.35.35,0,0,1,.12,0,.12.12,0,0,1,0,.22l-1.27.73a.68.68,0,0,1-.32.09h-.24l-2.42-.24.43,1.38s0,.08,0,.14,0,.12-.16.19l-1.28.74a.43.43,0,0,1-.36,0,.23.23,0,0,1-.07-.07l-.78-2.59-4.58-.44h-.07l-.05,0a.12.12,0,0,1,0-.22l1.27-.73a.71.71,0,0,1,.29-.1h.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.62,253.79a.61.61,0,0,1-.34.1,1.37,1.37,0,0,1-.31,0l-7.08-2a.49.49,0,0,1-.16-.05c-.05,0-.08-.06-.08-.11s0-.07.08-.1l1-.61a.66.66,0,0,1,.31-.1.75.75,0,0,1,.23,0l.92.27,2.23-1.29-.46-.53a.17.17,0,0,1-.05-.13c0-.06.05-.12.16-.18l1.06-.61a.42.42,0,0,1,.36,0l.1.09,3.44,4.09a.28.28,0,0,1,.06.18c0,.07-.05.14-.16.2Zm-2.29-2.89-1.36.78,2.68.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,254.36h.25l2.16.34-2.76-1.59c-.07,0-.1-.08-.1-.13a.14.14,0,0,1,.1-.13l1.09-.64a.52.52,0,0,1,.23-.05.51.51,0,0,1,.22.05l5.4,3.12c.06,0,.09.08.09.13a.15.15,0,0,1-.09.13l-1,.56a.53.53,0,0,1-.34.09h-.24l-3.67-.55,1,2.11a.41.41,0,0,1,0,.14c0,.07,0,.14-.16.2l-1,.56a.43.43,0,0,1-.23.05.41.41,0,0,1-.23-.05l-5.4-3.12a.15.15,0,0,1-.09-.13s0-.09.09-.13l1.1-.63a.41.41,0,0,1,.23-.05.38.38,0,0,1,.22.05l2.77,1.6L351,255a.61.61,0,0,1,0-.15s0-.1.12-.15l.54-.31A.5.5,0,0,1,351.9,254.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.53,240.53c0,.08.1.08.11,0a.54.54,0,0,1,.56-.52,2,2,0,0,1,.65,0s.06,0,.07,0a4,4,0,0,1,.18-.59c.15.11.34.24.46.06s0-.85.4-.48c0,0,.07,0,.1,0,.21-.33.44-.35.61-.15a1.44,1.44,0,0,0,.17.33c.06.09.12,0,.1-.1a1.8,1.8,0,0,0-.09-.28A1,1,0,0,1,337,238c.36-.26.78.35.84.64h0v0c0,.13.17.06.15-.06s0,0,0,0a1.29,1.29,0,0,1,.11-.84c.2-.33.45-.17.66.08.06.07.11,0,.11-.09,0-.4.31-1,.7-.49,0,.07.11,0,.12,0l.12-.48c0-.11.06-.22.1-.33s.07-.18.17-.05.24.3.43.28.29-.38.28-.64c.15.08.34.16.48.07a.75.75,0,0,0,.22-.51c.12.11.27.22.43.12s.21-.39.25-.59a.73.73,0,0,1,.43.36c0,.07.09,0,.1-.06s-.06-.52,0-.7c.2-.34.63.27.71.49s.18.08.17,0c0-.36-.11-1.45.45-1.4a.5.5,0,0,1,.27.1,1.27,1.27,0,0,0,.72,1.52.08.08,0,0,0,.1-.05,1.66,1.66,0,0,0-.59-1.58,1.12,1.12,0,0,1,.16-.22c.2-.19.48-.07.65-.27s0-.15.22-.27.22-.08.37.05a1,1,0,0,1,.19.22c0,.07.11,0,.11-.07s0-.47.22-.53.36.14.47.23.11,0,.12,0a2.54,2.54,0,0,0,0-.29,1.36,1.36,0,0,1,0-.2c.06-.15.29-.43.42,0,0,.11.17.08.16,0a1.18,1.18,0,0,1,.3-.84.68.68,0,0,1,.4-.21h0a.58.58,0,0,0,0,.18c0,.21.08.55.32.61s.36-.13.41-.31a.56.56,0,0,0-.32-.61h0a2.12,2.12,0,0,1,.48-.23,1.62,1.62,0,0,0,.41-.17s.08-.16.12-.18c.37-.21.19,0,.37,0a.58.58,0,0,0,.58-.48c.31.31.56-.15.66-.49.13.18.29.48.5.53s.43-.16.58-.29,0,0,0,0c-.2.16-.41.33-.65.15a3.56,3.56,0,0,1-.41-.53s-.06,0-.06,0c-.05.22-.3.85-.59.43,0-.05-.09,0-.1,0-.08.36-.26.47-.61.38-.15,0-.18-.07-.31,0s-.11.18-.22.24l-.17.07a3.56,3.56,0,0,0-.49.19.9.9,0,0,0-.27.2c-.53-.12-.92.44-1,1a.33.33,0,0,0-.46,0c-.17.14-.16.42-.17.65-.17-.13-.37-.27-.57-.16a.57.57,0,0,0-.23.5c-.2-.22-.49-.41-.73-.16s.19.17-.36.37c-.07,0-.15,0-.23,0a.94.94,0,0,0-.36.38l0,.07a1.06,1.06,0,0,0-.2-.12c-.77-.32-.82.62-.81,1.24-.16-.24-.39-.47-.62-.45s-.29.54-.24.88a.91.91,0,0,0-.42-.29s-.06,0-.07,0a2.7,2.7,0,0,1-.08.41c-.13.31-.34.2-.5,0s-.07,0-.08,0-.05.45-.21.52-.36-.11-.47-.18-.1,0-.1.07c0,.22.07.69-.33.47-.13-.07-.21-.23-.35-.3a.08.08,0,0,0-.09,0,3.11,3.11,0,0,0-.29.94c-.4-.45-.81.06-.85.57-.2-.22-.48-.39-.73-.1a1,1,0,0,0-.22.68c-.21-.33-.54-.6-.88-.45a.71.71,0,0,0-.33.82l-.09,0c-.27-.09-.43.11-.53.33l-.2-.15s0,0-.06,0a.66.66,0,0,0-.22.4,1,1,0,0,1,0,.24c-.11.18-.24,0-.36-.11a.09.09,0,0,0-.1,0c-.19.19-.12.36-.18.6s-.06.12-.27.06a1.14,1.14,0,0,0-.37-.05C333.66,239.71,333.46,240,333.53,240.53Zm15.48-9c0,.13-.12.29-.26.25s-.22-.37-.11-.56C348.81,231.25,349,231.35,349,231.51Zm-4,3.51a1,1,0,0,1-.54-1.12A1.48,1.48,0,0,1,345.05,235Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344.62,228.92a.79.79,0,0,0,.48-.2,6.79,6.79,0,0,1,.6.58c.06.08.12,0,.11-.09a.81.81,0,0,1,.23-.55c.13-.13.23-.09.39-.06s.25-.06.26-.2c.24.09.36-.16.43-.4.11.09.24.16.37.07a.87.87,0,0,0,.27-.44c.2.14.3.52.59.46s.43-.4.48-.62c0-.06-.05-.07-.07,0s-.29.61-.55.49-.25-.37-.45-.47c0,0,0,0-.05,0-.11.28-.26.62-.58.32,0,0-.07,0-.08,0-.05.19-.15.52-.4.33-.06,0-.09.05-.08.1,0,.21-.16.1-.28.09a.34.34,0,0,0-.29.08.91.91,0,0,0-.32.54l-.33-.3-.15-.13a.11.11,0,0,0,0-.07.49.49,0,0,0-.36-.62s-.06,0-.07.05a.62.62,0,0,0,.17.64c-.12.07-.26.08-.37.15S344.53,228.92,344.62,228.92Zm.3-.81a.26.26,0,0,1,.16.35A.53.53,0,0,1,344.92,228.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M328.94,242.24a.83.83,0,0,0,.47-.2c.21.21.47.4.6.57s.12,0,.12-.09a.75.75,0,0,1,.22-.54c.14-.13.24-.09.4-.06s.24-.07.25-.2c.24.09.37-.16.44-.4a.29.29,0,0,0,.37.06.88.88,0,0,0,.27-.43c.2.13.29.52.59.45s.42-.39.47-.61c0-.06-.05-.07-.06,0-.05.21-.3.61-.56.48s-.24-.36-.44-.46c0,0-.05,0-.05,0-.12.28-.27.63-.59.32,0,0-.06,0-.07.05-.06.19-.15.51-.41.33-.06,0-.09,0-.08.1,0,.21-.15.1-.27.08a.43.43,0,0,0-.29.08,1,1,0,0,0-.33.55c-.1-.11-.22-.2-.33-.3l-.14-.13,0-.07a.5.5,0,0,0-.37-.62s-.06,0-.07,0a.62.62,0,0,0,.17.64c-.11.07-.25.08-.37.15S328.85,242.24,328.94,242.24Zm.29-.81a.26.26,0,0,1,.17.35A.55.55,0,0,1,329.23,241.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340.42,232.43s0,0,0,0,0-.27.14-.31.25.07.34.12.06,0,.07-.06,0-.32.11-.37.27.16.32.22.1,0,.1-.06.1-.64.35-.6a.38.38,0,0,1,.17.08.82.82,0,0,0,.29.72c.07,0,.1,0,.11-.09a1.18,1.18,0,0,0-.26-.77.64.64,0,0,1,.2-.41c.16-.12.28,0,.44,0a.26.26,0,0,0,.18-.2c.2.14.33-.08.42-.27.27.19.47,0,.53-.3a.57.57,0,0,0,.39.15c.23,0,.2-.27.17-.43s-.09,0-.08,0c0,.36-.37.09-.5,0s-.13,0-.12.07c0,.25-.15.48-.38.27a.07.07,0,0,0-.09,0c-.06.15-.14.45-.35.27,0,0-.08,0-.09.05,0,.31-.24.11-.44.15a.52.52,0,0,0-.36.37l0,.14a.48.48,0,0,0-.25-.09c-.34,0-.4.38-.41.68-.1-.11-.22-.23-.35-.17s-.15.29-.16.45c-.12-.08-.3-.17-.43-.07S340.37,232.3,340.42,232.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340,232.6s0,0,0,0l0,0h0s0,0,0,0l0,0h.13l.09.06h0s0,0,0,0a.13.13,0,0,0,0-.09.35.35,0,0,0-.2-.05.22.22,0,0,0-.15.16S340,232.59,340,232.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339.44,233.23s0,0,0,0a.44.44,0,0,1,.13-.35.94.94,0,0,1,.32-.11l.28-.07c.05,0,.05-.14,0-.12s-.31.08-.47.12l-.15.07a.4.4,0,0,0-.1.18A.93.93,0,0,0,339.44,233.23Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M331.92,237.24s.07,0,.08,0c.12-.36.4-.33.58,0,0,.06.07,0,.07-.05a1.59,1.59,0,0,1,.16-.81c.18-.28.3,0,.51,0s.24-.23.25-.42c.18.1.35,0,.42-.23.21.17.37.05.46-.21.11.1.26.27.37.24s.21-1.09.52-.47l.05.05a.14.14,0,0,0,.05.11.42.42,0,0,0,.68-.21c.15-.33.26-1.55.79-.78,0,.06.11,0,.11,0,0-.26,0-.62.34-.31,0,0,.09,0,.09-.07s0-.61.29-.41a.79.79,0,0,1,.28.45c0,.08.1,0,.09-.05a1.33,1.33,0,0,1,.19-.93c0-.05,0-.14-.06-.07a1.69,1.69,0,0,0-.25.7c-.1-.18-.25-.37-.42-.34s-.23.27-.24.46c-.32-.25-.4,0-.43.35-.2-.22-.45-.28-.66,0a1.75,1.75,0,0,0-.15.5.6.6,0,0,0-.16-.33c-.32-.29-.52.2-.59.56-.12-.15-.27-.22-.41,0s-.13.52-.18.53-.27-.23-.32-.25-.09,0-.1.06-.12.25-.34.13c0-.05-.11,0-.12.05s-.1.24-.31.19-.15-.05-.15,0,0,.24,0,.3-.21,0-.31,0a.28.28,0,0,0-.34.12,1.31,1.31,0,0,0-.18.85c-.21-.28-.54-.3-.63.07a3.84,3.84,0,0,1-.85-1.39c0-.1-.12,0-.12.06C331,236.36,331.58,236.77,331.92,237.24Zm3.75-2.62c.25-.19.27.29.19.43a.34.34,0,0,1-.38.19h0A.83.83,0,0,1,335.67,234.62Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M338.07,228.67a4.17,4.17,0,0,0,1,1.86c.05.05.13.08.16,0s0-.8.23-.89.32.31.5.41.07,0,.09,0c.14-.28.1-.67.27-.93.07.1.16.2.28.13a.52.52,0,0,0,.14-.37c.24.16.39,0,.47-.28.26.24.44.06.58-.24a.56.56,0,0,0,.35.23.08.08,0,0,0,.08,0c0-.15.07-.3.11-.45.1-.4.33,0,.43.17a.06.06,0,0,0,.12,0,2.71,2.71,0,0,0,.12-.58.59.59,0,0,1,.05-.19.27.27,0,0,1,.35-.07c.11.06.17.28.2.39s.15.09.14,0c0-.35-.08-1,.3-1.19a.34.34,0,0,1,.26,0,.74.74,0,0,0-.09.56c.1.35.43.27.47-.07a.81.81,0,0,0-.14-.51,1.25,1.25,0,0,1,.49-.42c.07,0,.05-.22,0-.18a1.64,1.64,0,0,0-.58.46.38.38,0,0,0-.43-.06c-.34.16-.39.62-.4,1-.1-.18-.26-.32-.47-.25s-.27.54-.32.83c-.11-.19-.27-.42-.46-.29s-.14.25-.16.36,0,.26-.07.29-.25-.19-.29-.23-.09,0-.11,0c-.1.22-.22.53-.49.2,0-.05-.11,0-.12.05s-.09.52-.36.24c-.05,0-.11,0-.12.05s-.05.5-.23.22a.08.08,0,0,0-.12,0c-.24.25-.2.64-.32,1-.17-.16-.25-.51-.55-.39s-.3.5-.33.81a5.29,5.29,0,0,1-.8-1.57C338.2,228.46,338,228.5,338.07,228.67Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.65,232.58a.33.33,0,0,0,.19-.31c.11.1.22.27.37.18a.36.36,0,0,0,.13-.28.3.3,0,0,0,.43.06c.14-.11.12-.26.13-.42a.21.21,0,0,0,.14.11c.09,0,.15-.07.19-.14a2.21,2.21,0,0,0,.15-.5,1.3,1.3,0,0,0,.5.41c.3.09.37-.3.4-.51s-.14-.19-.15,0-.07.43-.29.31a1.72,1.72,0,0,1-.45-.4s-.09,0-.11,0-.06.3-.11.44,0,.17-.09.2-.13-.1-.16-.15-.09,0-.1,0,0,.29-.05.41a.22.22,0,0,1-.26.1.61.61,0,0,1-.19-.2c-.06-.08-.11,0-.1.09s0,.38-.14.32-.18-.2-.29-.26-.07.07-.07.1a.53.53,0,0,1-.09.36S334.61,232.6,334.65,232.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M325.13,245.11a.31.31,0,0,0,.18-.31c.11.1.23.27.38.17a.36.36,0,0,0,.13-.28.29.29,0,0,0,.43.07c.13-.11.12-.27.13-.42a.19.19,0,0,0,.14.11c.09,0,.15-.07.19-.14a2.19,2.19,0,0,0,.14-.5,1.3,1.3,0,0,0,.51.4c.3.1.37-.3.39-.5s-.13-.19-.14,0-.07.43-.29.31a2.54,2.54,0,0,1-.46-.4c0-.05-.08,0-.1,0s-.06.31-.11.45,0,.17-.1.2-.13-.1-.15-.15-.09,0-.11,0,0,.29-.05.41a.19.19,0,0,1-.25.1.46.46,0,0,1-.2-.19c-.06-.09-.1,0-.1.09s0,.38-.14.31-.17-.19-.28-.25-.07.06-.07.09a.56.56,0,0,1-.09.36S325.09,245.12,325.13,245.11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M327.28,237.62s.08,0,.08-.05a2.66,2.66,0,0,1,.08-.8c0-.15.12-.3.29-.32s.25.12.39.18c.4.18.52-.33.54-.65.15.06.27,0,.33-.1.23.21.4,0,.45-.32.13.13.24.24.41.07s.13-.36.15-.56c.17.16.35.36.59.19s.21-.46.24-.71a1.72,1.72,0,0,1,.37.22s0,0,.05,0a1.14,1.14,0,0,0,.1-.19.36.36,0,0,1,.16-.24,1,1,0,0,1,.33.25.06.06,0,0,0,.1,0c.07-.12.08-.25.14-.37s.24-.17.42,0,.12,0,.14-.06a3.78,3.78,0,0,1,.06-.47c.15-.44.56,0,.66.25s.13,0,.13,0c0-.25-.16-.87.13-1,.06,0,.05-.18,0-.16-.29.09-.28.49-.26.81-.15-.21-.38-.4-.62-.28s-.22.38-.24.61c-.13-.09-.29-.18-.43-.06a1,1,0,0,0-.21.53,2.88,2.88,0,0,0-.38-.22,0,0,0,0,0-.06,0,1.78,1.78,0,0,0-.12.29c-.13.25-.26,0-.45,0s-.06,0-.07.05c0,.19,0,.6-.24.69s-.39-.17-.52-.3-.09,0-.11,0,0,.22,0,.31-.22.27-.31.24l-.12-.11c-.06,0-.09.06-.09.1,0,.22-.07.31-.32.27-.06-.06-.11,0-.11.07s-.13.18-.25.06-.08,0-.08.05a3.58,3.58,0,0,1-.09.45.29.29,0,0,1-.32.22s-.13-.12-.17-.15a.42.42,0,0,0-.51,0c-.26.22-.24.68-.22,1a2.94,2.94,0,0,1-.78-1.32c0-.09-.11-.06-.11,0C326.32,236.69,327,237.17,327.28,237.62Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "346.27 253.51 342.37 255.79 339.4 254.08 343.31 251.8 346.27 253.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,253.54,343.27,252l-3.59,2.09,2.72,1.57Zm-2.79-1.8.13,0a.4.4,0,0,1,.2,0l3,1.71s0,.06,0,.09l-3.91,2.28a.65.65,0,0,1-.22.05.42.42,0,0,1-.21,0l-3-1.71s0,0,0-.08l3.9-2.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,239.85l-.22-.13a.54.54,0,0,0-.49,0L348,251.93c-.15.09-.18.22-.07.29l.22.12a.54.54,0,0,0,.49,0l21.08-12.17C369.87,240,369.9,239.91,369.79,239.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.49,239.1l-.21-.13a.57.57,0,0,0-.49,0l-21.08,12.17c-.16.09-.19.22-.07.29l.21.12a.56.56,0,0,0,.5,0l21.07-12.17C368.58,239.29,368.61,239.16,368.49,239.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.2,238.35l-.21-.12a.54.54,0,0,0-.49,0l-21.08,12.17c-.16.09-.19.22-.07.28l.21.13a.6.6,0,0,0,.5,0l21.07-12.17C367.29,238.55,367.32,238.42,367.2,238.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.96 253.37 343.79 253.37 343.79 253.82 342.75 253.82 342.75 256.32 341.96 256.32 341.96 253.37",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.83 250.37 336.93 252.65 333.96 250.94 337.87 248.66 340.83 250.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,250.4l-2.72-1.57-3.59,2.09,2.73,1.57Zm-2.79-1.8.13,0a.38.38,0,0,1,.2,0l3,1.71s0,.06,0,.09l-3.91,2.28a.6.6,0,0,1-.22,0,.42.42,0,0,1-.21,0l-3-1.71s0-.05,0-.08l3.9-2.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.35,236.71l-.21-.13a.56.56,0,0,0-.5,0l-21.07,12.17c-.16.09-.19.22-.07.29l.21.12a.54.54,0,0,0,.49,0L364.28,237C364.43,236.9,364.47,236.77,364.35,236.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,236l-.21-.13a.57.57,0,0,0-.49,0L341.27,248c-.16.09-.19.22-.07.29l.22.12a.54.54,0,0,0,.49,0L363,236.24C363.14,236.15,363.17,236,363.05,236Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.77,235.21l-.22-.12a.54.54,0,0,0-.49,0L340,247.3c-.15.09-.18.22-.07.28l.22.13a.58.58,0,0,0,.49,0L361.7,235.5C361.85,235.41,361.88,235.28,361.77,235.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.39 247.23 331.49 249.51 328.52 247.8 332.43 245.52 335.39 247.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.11,247.26l-2.72-1.57-3.58,2.09,2.72,1.57Zm-2.79-1.8.13,0a.38.38,0,0,1,.2,0l3,1.71s0,.06,0,.09l-3.91,2.28a.6.6,0,0,1-.22.05.37.37,0,0,1-.2,0l-3-1.71s0-.05,0-.08l3.91-2.28A.19.19,0,0,1,332.32,245.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.91,233.57l-.21-.13a.56.56,0,0,0-.5,0l-21.07,12.17c-.16.09-.19.22-.07.29l.21.12a.54.54,0,0,0,.49,0l21.08-12.17C359,233.76,359,233.63,358.91,233.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.62,232.82l-.22-.13a.57.57,0,0,0-.49,0L335.83,244.9c-.15.09-.18.22-.07.29l.22.12a.54.54,0,0,0,.49,0l21.08-12.17C357.7,233,357.73,232.88,357.62,232.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33,232.07l-.22-.12a.54.54,0,0,0-.49,0l-21.08,12.17c-.15.09-.18.22-.07.28l.22.13a.54.54,0,0,0,.49,0l21.08-12.17C356.41,232.27,356.44,232.14,356.33,232.07Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323,232.47l2.81,6.48a.22.22,0,0,1-.31.27l-6.2-3.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,239.22a.22.22,0,0,0,.31-.27l-.55-1.27h0a1.19,1.19,0,0,1-1,.78l-.12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,213.68l.44.48.53.59,19,21a3.14,3.14,0,0,0,2.21-.68,3.21,3.21,0,0,0,1.49-2.61l-19-21-1-1.12C303.61,211.11,300,214.43,299.33,213.68Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,215.53l1,1.08c.28.32,1.13-.08,2-.71,1.11-.83,2.06-2.21,1.7-2.63l-.72-.8-.26-.28c.36.43-.59,1.8-1.7,2.63-.8.6-1.62,1-1.92.74h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,215.8c.64.75,4.29-2.59,3.65-3.35l-1-1.08c.63.75-3,4.09-3.66,3.34Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,213.68l1,1.07c.61.74,4.17-2.45,3.71-3.28l0-.05-1-1.07C303.61,211.11,300,214.43,299.33,213.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.74,239.2l.07-.25-3.76-4.33L302,212.4q.09-.09,0-.12c-1,1-2.27,1.82-2.62,1.4l.44.48.53.59,19,21h0l6.2,3.46A.21.21,0,0,0,325.74,239.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.23,209.14l4.1,4.54c.27.32,1.11-.07,1.94-.69,1.12-.83,2.08-2.2,1.73-2.64h0l-4.11-4.56c-.82-.9-2.86.54-3.61,1.91A1.27,1.27,0,0,0,295.23,209.14Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.91,209.1a3.87,3.87,0,0,0,2.1-2.68.86.86,0,0,0-.27-.75c-.9-.62-2.76.73-3.47,2a1.26,1.26,0,0,0,0,1.41C295.53,209.45,296.16,209.47,296.91,209.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31,218.44a4.84,4.84,0,0,1,3.77,2.06c1.07,1.19,2.94,1.87,2.9,2.57s-1.22,1.39-1.22,1.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.12,237.27a12.53,12.53,0,0,0,7.69-1.82c.57-.37,1.1-.78,1.66-1.16a4,4,0,0,1,1.42-.78c.42-.09.86-.12,1.27-.23a3.41,3.41,0,0,0,2.26-2,6.07,6.07,0,0,1,.24-.59.81.81,0,0,1,.48-.39,1.05,1.05,0,0,1,.64.12,9.89,9.89,0,0,0,2.33.8,4.52,4.52,0,0,0,1.83-.09c.45-.13,1.36-.65.83-1.21-.7-.76-1.37-1.55-2-2.06-3.08-2.69-6-3.86-9.77-5.33-1.76-.67-4.28-1.39-6.05-2-.76-.27-1.53-.66-2.32-1l-1-1.07a5.27,5.27,0,0,0-2.33.14c-1.21.31-2.63,1-3.84,1.22-3.09.67-7.82-1.83-11.64-3.08-7.52-2.46-27.3-11.41-27.3-11.41l3.77-34.09c1.08-8.9-.75-25.91-3.58-36.55-4.37,1.18-9.2,1.25-13.43,6.19-2.92,3.42-5.3,8.15-6.55,21.79-1,11-3.89,30.69-3.89,48.45,0,11.13,4.74,11.08,14.31,14.16,1.37.43,2.75.8,4.14,1.16,5.4,1.4,10.84,2.61,16.29,3.79q9.69,2.1,19.43,3.95C291,234.7,300,237.07,303.12,237.27Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,205.31a20,20,0,0,0-10.63-.68s3.63-2.94,10.82-1.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79,134.67c-6.09.8-11.51,2.78-15.28,7.48-4.2,5.24-5.3,13.95-6,21.78-.63,6.62-2.06,23.64-2.06,23.64s8.33,7,25.24,3.49l3.41-31S263.11,145.46,257.79,134.67Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79,134.67c-6.09.8-11.51,2.78-15.28,7.48-4.2,5.24-5.3,13.95-6,21.78-.63,6.62-2.06,23.64-2.06,23.64s8.33,7,25.24,3.49l3.41-31S263.11,145.46,257.79,134.67Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Finger--inject-12",
    d: "M362.89,217a18.21,18.21,0,0,0,5.67,8.36,24.66,24.66,0,0,1,5.16,5.68c1.21,1.61,2.85.17,2.23-2.57-.48-2.13-2.69-5-3.12-7.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.84,391.81l-11.19-84.66-9.25-.47,15.78,85.12h0a1.23,1.23,0,0,0,.62.83,3.64,3.64,0,0,0,3.29.16,1.11,1.11,0,0,0,.73-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.65,307.15l-9.25-.47,3.28,17.7a28.74,28.74,0,0,0,5.66-2.75,4.69,4.69,0,0,0,2-1.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.76,298.12H78.5L65,383.81h0a1.11,1.11,0,0,0,.68,1,3.62,3.62,0,0,0,3.3,0,1.25,1.25,0,0,0,.66-.8h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,298.12,74.63,322.8a36.68,36.68,0,0,0,7,4.42l6.13-29.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,423.47l-8.58-86.25-9.25-.47,13.17,86.71h0a1.25,1.25,0,0,0,.62.83,3.64,3.64,0,0,0,3.29.16,1.11,1.11,0,0,0,.73-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,351.3l-1.4-14.08-9.25-.47,2.31,15.16C139.51,352.53,143.1,352.17,145.79,351.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,268.74H129l-13.46,85.69h0a1.11,1.11,0,0,0,.68,1,3.69,3.69,0,0,0,3.3,0,1.28,1.28,0,0,0,.65-.8h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,271.21a8.75,8.75,0,0,0-1.24-.13L117,345.6c1.69.92,2.91,1.59,4.61,2.46l16-75.24C135.05,272.24,132.53,271.69,130,271.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.65,302.68c0-2.91-2.57-6-8-9.54-10-6.48-39.09-22.73-53.08-30.48a.14.14,0,0,0-.12-.11c-10.77-6.54-14-34.43-21.49-58.07-.16-.5-.31-1-.48-1.46s-.26-.75-.39-1.1c-.47-1.29-.95-2.46-1.47-3.54-.11-.25-.23-.49-.34-.72a26.29,26.29,0,0,0-1.55-2.77l-.42-.63c-.26-.39-.53-.74-.81-1.09-.15-.19-.3-.36-.46-.54a10.12,10.12,0,0,0-.76-.83c-.21-.22-.42-.42-.64-.61a12.8,12.8,0,0,0-2-1.46l-.52-.3a.09.09,0,0,0-.06,0l-.13-.07-.23-.14L112.47,188l-.59-.34a1.75,1.75,0,0,1-.27-.16l-.79-.45a10.52,10.52,0,0,0-2.16-1l-.75-.23c-.28-.07-.57-.14-.86-.19a18.13,18.13,0,0,0-8.57.92l-.68.22c-.67.24-1.36.49-2,.77h0c-.92.37-1.88.79-2.84,1.23-3.39,1.56-7.05,3.56-10.94,5.7-.47.25-.93.51-1.39.78s-1.1.63-1.64,1l-1,.65c-.87.55-1.72,1.13-2.54,1.75-.41.3-.82.62-1.23.94s-.79.65-1.18,1c-.59.51-1.15,1-1.7,1.6a14.34,14.34,0,0,0-1.08,1.12,27.13,27.13,0,0,0-2,2.45l0,0c-.16.21-.31.43-.46.64q-.48.69-.93,1.41c-.44.7-.86,1.44-1.26,2.2-.14.26-.27.53-.4.79s-.26.53-.38.8l-.37.84a52.64,52.64,0,0,0-3.7,16.26c-1.06,12.46,0,36.28,2.48,54.32h0c3.67,30.15,8.16,30.21,14.7,35.25C89,326.89,114.34,339.09,125,343.29c19.35,7.61,35.16-4.13,47-10a274,274,0,0,0,31.23-18.5c2.95-2.15,4.48-4.31,4.45-6.6C207.62,307.34,207.65,303.63,207.65,302.68Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,302.68c0-2.91-2.57-6-8-9.54-10-6.48-39.09-22.73-53.08-30.48a.14.14,0,0,0-.12-.11c-10.77-6.54-14-34.43-21.49-58.07-.16-.5-.31-1-.48-1.46s-.26-.75-.39-1.1c-.47-1.29-.95-2.46-1.47-3.54-.11-.25-.23-.49-.34-.72a26.29,26.29,0,0,0-1.55-2.77l-.42-.63c-.26-.39-.53-.74-.81-1.09-.15-.19-.3-.36-.46-.54a10.12,10.12,0,0,0-.76-.83c-.21-.22-.42-.42-.64-.61a12.8,12.8,0,0,0-2-1.46l-.52-.3a.09.09,0,0,0-.06,0l-.13-.07-.23-.14L112.47,188l-.59-.34a1.75,1.75,0,0,1-.27-.16l-.79-.45a10.52,10.52,0,0,0-2.16-1l-.75-.23c-.28-.07-.57-.14-.86-.19a18.13,18.13,0,0,0-8.57.92l-.68.22c-.67.24-1.36.49-2,.77h0c-.92.37-1.88.79-2.84,1.23-3.39,1.56-7.05,3.56-10.94,5.7-.47.25-.93.51-1.39.78s-1.1.63-1.64,1l-1,.65c-.87.55-1.72,1.13-2.54,1.75-.41.3-.82.62-1.23.94s-.79.65-1.18,1c-.59.51-1.15,1-1.7,1.6a14.34,14.34,0,0,0-1.08,1.12,27.13,27.13,0,0,0-2,2.45l0,0c-.16.21-.31.43-.46.64q-.48.69-.93,1.41c-.44.7-.86,1.44-1.26,2.2-.14.26-.27.53-.4.79s-.26.53-.38.8l-.37.84a52.64,52.64,0,0,0-3.7,16.26c-1.06,12.46,0,36.28,2.48,54.32h0c3.67,30.15,8.16,30.21,14.7,35.25C89,326.89,114.34,339.09,125,343.29c19.35,7.61,35.16-4.13,47-10a274,274,0,0,0,31.23-18.5c2.95-2.15,4.48-4.31,4.45-6.6C207.62,307.34,207.65,303.63,207.65,302.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,327.73a274.91,274.91,0,0,0,31.23-18.5c6.71-4.87,6.09-9.85-3.52-16.09-13.35-8.66-60.77-34.73-60.77-34.73S70.09,299,73.05,306.52s38.54,25.88,52,31.16C144.36,345.29,160.17,333.55,172,327.73Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,327.73a274.91,274.91,0,0,0,31.23-18.5c6.71-4.87,6.09-9.85-3.52-16.09-13.35-8.66-60.77-34.73-60.77-34.73S70.09,299,73.05,306.52s38.54,25.88,52,31.16C144.36,345.29,160.17,333.55,172,327.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,337.37c7.42-2.73,14-6.86,19.61-9.64a274.91,274.91,0,0,0,31.23-18.5c.19-.14.36-.28.53-.42a15.17,15.17,0,0,0-4-5.8c-8.69-8.35-39.39-30.83-53.29-30.49S93.26,292.45,89,295.8c-7.31,5.7-3.32,12.2,3.91,16.46s30.57,16.68,43.92,21.24C143.16,335.68,148.21,336.38,152.35,337.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,189.48c-7.24-3.8-16.66,1.37-28.3,7.74-7.46,4.09-13.81,8.94-17.67,18l-4.92-2.84c3.86-9,10.2-13.87,17.64-17.95,12-6.55,21.55-11.8,28.86-7.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,189.48c-7.24-3.8-16.66,1.37-28.3,7.74-7.46,4.09-13.81,8.94-17.67,18l-4.92-2.84c3.86-9,10.2-13.87,17.64-17.95,12-6.55,21.55-11.8,28.86-7.42Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,204.48c-.16-.5-.31-1-.48-1.46s-.26-.75-.39-1.1c-.47-1.29-.95-2.46-1.47-3.54-.11-.25-.23-.49-.34-.72a26.29,26.29,0,0,0-1.55-2.77l-.42-.63c-.26-.39-.53-.74-.81-1.09-.15-.19-.3-.36-.46-.54a10.12,10.12,0,0,0-.76-.83c-.21-.22-.42-.42-.64-.61s-.7-.58-1.05-.84-.47-.31-.7-.45l-.26-.17-.52-.3a.09.09,0,0,0-.06,0l-.13-.07-.37-.17-.54-.23a11.56,11.56,0,0,0-2.15-.57,5.4,5.4,0,0,0-.58-.09c-.28,0-.56-.06-.85-.07l-.71,0c-6.32,0-13.92,4.18-22.82,9-.74.4-1.48.82-2.2,1.25l-.83.5c-.33.19-.66.4-1,.61l-.72.47a41.43,41.43,0,0,0-4.49,3.41c-.23.2-.45.4-.67.62a27.66,27.66,0,0,0-2.54,2.64c-.15.16-.3.33-.43.5s-.35.42-.5.63-.33.43-.5.65l-.47.66A33.33,33.33,0,0,0,70.8,212l-.21.38-.42.81c-.2.4-.38.79-.57,1.19a51.22,51.22,0,0,0-4,17c-1.73,20.48,2.07,71.6,9.11,77.43,0,0-1.08-6.62,13.08-15.53,9.62-6.05,16.38-11.14,26.65-16.18,25-12.3,32.05-14.6,32.05-14.6C135.69,256,132.43,228.12,125,204.48Z",
    style: {
      fill: "#D175F7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.28,353.15c-6-.58-11,4.42-11.41,6-.58,2.1-.19,6.29,2.45,11.38,2.29,4.4,3.53,11.44,3.28,16.19s-2,16.67,3,22.42,15.83,10.53,19.29,2.24c1.13-2.7-1.71-11.83-3.08-18.52-2.73-13.32-5-26.58-5-26.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,363.92a130.48,130.48,0,0,1,2.29,19.61c.16,7.2,1.86,11.87,4.47,15,2.88,3.43,9.8,5.14,8.71-2.23-.77-5.14-5.46-30-5.46-30Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,356.68c-.1,4.44,2.74,16.11,9.12,25.73,6.25,9.43,15.3,20.46,17.21,27.29,0-3.17-1.52-8.92-2.71-14,0-.12,0-.23-.08-.34-.07-.3-.13-.6-.2-.89L182,394l-.24-1.13v-.07c-.86-4.16-1.66-8.32-2.36-12.07-.56-3-1.06-5.73-1.46-8-.2-1.13-.38-2.15-.53-3q-.12-.64-.21-1.2c-.25-1.45-.39-2.28-.39-2.28l-8.54-13.1c-.41,0-.79,0-1.17,0A13.16,13.16,0,0,0,158.77,356.68Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,281.59c-18.63-13.24-39.56-25.11-39.56-25.11l-19.2,22,21.59,16.8,22.81,21.28s4.93-.72,2.42,7.21c-.79,2.52-1.91,7.53-3.07,13.2l20.74,25.17s4.83-15.55,8.72-26.26c6.87-18.87,9.84-27.54,8.68-31.79C207,298.52,200.24,292.12,185.42,281.59Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,281.59c-18.63-13.24-39.56-25.11-39.56-25.11l-19.2,22,21.59,16.8,22.81,21.28s4.93-.72,2.42,7.21c-.79,2.52-1.91,7.53-3.07,13.2l20.74,25.17s4.83-15.55,8.72-26.26c6.87-18.87,9.84-27.54,8.68-31.79C207,298.52,200.24,292.12,185.42,281.59Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,281.59c-18.63-13.24-39.56-25.11-39.56-25.11l-19.2,22,21.59,16.8,22.81,21.28s4.93-.72,2.42,7.21c-.79,2.52-1.91,7.53-3.07,13.2l20.74,25.17s4.83-15.55,8.72-26.26c6.87-18.87,9.84-27.54,8.68-31.79C207,298.52,200.24,292.12,185.42,281.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.16,285s24.08,19.56,29.43,24.85,8.45,6.74,9.91,19.61c1.24,10.87,4.05,29.82,4.05,29.82L152,318.7l-12.25-28.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,407.58c-1.46,0-1.42,2.48-2.14,5.68-.46,2.08-1.37,5.55,0,9.48s7.75,4.42,11.13,9.56,8.33,14.42,19.65,17,20.05-1,22.22-4.37.33-6.58-6.87-10.85c-7.65-4.54-9.81-5.87-9.81-5.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,387.51s2.13,13.39,6.17,19.88,8.39,13.71,14.14,20c1.25,1.36,4.09,3.88,5.11,5a2.19,2.19,0,0,1-.13,3.38c-2.4,2.43-12.86,3.31-18.86-.91s-11.64-13.44-15.24-16.87c-1.36-1.29-2.64-2.62-3.86-4a7.26,7.26,0,0,1-1.94-4.62,21.16,21.16,0,0,0-.64-6.74c-.92-3.67-1.77-5.07-3-8.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,255c-6.31,15.79-8.41,31.39-4.72,39.55,5,11.12,11.81,15.34,28.18,23.92,13.55,7.1,35.59,15,39.55,16.77,3,1.31,3.62,3.36,4.23,11.07.6,7.54,3.78,15.71,12.11,31.16,8.62,16,9.92,19.69,9.92,19.69s11,1.72,18.76-5.52c0,0-13.75-62.81-17.55-72.5s-44.68-35.93-44.68-35.93,15.36-11.74,10.51-29.48Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,255c-6.31,15.79-8.41,31.39-4.72,39.55,5,11.12,11.81,15.34,28.18,23.92,13.55,7.1,35.59,15,39.55,16.77,3,1.31,3.62,3.36,4.23,11.07.6,7.54,3.78,15.71,12.11,31.16,8.62,16,9.92,19.69,9.92,19.69s11,1.72,18.76-5.52c0,0-13.75-62.81-17.55-72.5s-44.68-35.93-44.68-35.93,15.36-11.74,10.51-29.48Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,272.29s-3.32,9.51-9.87,13.5l3.53,2.36A23.64,23.64,0,0,0,150.17,272.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.79,179.9c11.8-.26,18.86.46,22.24,17.28s7,41.16,7,41.16,25.9,16.44,30.91,19.33c2,1.13,7.09,2.58,9.82,5.55,4.26,4.61,14.51,16.48,14.51,16.48s-19.3-5.16-32.35-9.32c0,0-28.9-12.48-31.75-13.9-7.2-3.56-9.82-5-12.08-16.23s-7.6-41.11-7.6-41.11Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,255.09c1.38-5.06,3-8.73,3.44-12.2.46-3.65.13-9.12-2.09-16.79-3.87-13.37-1.64-32.27.46-39.2,5-1.91,15.88-4.94,15.88-4.94s10-.55,16.37-1.37a73.84,73.84,0,0,1,10.73-.69c4.53,4.37,16.55,18.67,19.38,27.28a19.09,19.09,0,0,1-5.91,20.72c-.78,5.88-1.3,12.29-1.53,17s2.26,10.19,4.64,14c-3.14,8.27-14.5,15-33.61,17C94.34,278.25,85,272.52,85,272.52S85.31,268.61,89,255.09Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,255.09c1.38-5.06,3-8.73,3.44-12.2.46-3.65.13-9.12-2.09-16.79-3.87-13.37-1.64-32.27.46-39.2,5-1.91,15.88-4.94,15.88-4.94s10-.55,16.37-1.37a73.84,73.84,0,0,1,10.73-.69c4.53,4.37,16.55,18.67,19.38,27.28a19.09,19.09,0,0,1-5.91,20.72c-.78,5.88-1.3,12.29-1.53,17s2.26,10.19,4.64,14c-3.14,8.27-14.5,15-33.61,17C94.34,278.25,85,272.52,85,272.52S85.31,268.61,89,255.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85,230.62s-5,6.74-15.59,6c-10.89-.77-13.36-9.67-13.36-9.67s0,11.79,13,12.72A15.65,15.65,0,0,0,131.85,230.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,118.44a16.74,16.74,0,0,0-13.12,7.64,18,18,0,0,0-1.05,18.48,15.34,15.34,0,0,0,4.42,27.2c-.07-1.64-.08-3.87.75-5.29a9.53,9.53,0,0,0,4.74,8c9.06,5.68,21.5.74,23.49-1.27,2.71-2.73,5.86-4.91,8.72-7.5l.36-.33c3.52-3.3,6.54-7.06,11-9,7.86-3.51,8.79-7.59,8.67-11.83a10.26,10.26,0,0,1,.33,6.09,16.61,16.61,0,0,0,3.23-15.91c-1.72-5.18-7-10.55-12.66-10.65-.6-3.67-4.28-8.71-10.72-11.23S115.15,108.25,108.55,118.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42,131.15c1.77,1.84,5.73,7.75,3.87,23.2-1.94,16.08-8.26,20.2-10.86,21.21s-6.74.67-12.62-1l-.87,8.06a14.72,14.72,0,0,1,5.63,7.69c1.25,4.15-7,7.42-16.87,1.07a26,26,0,0,1-8.17-7.91l2-22.49s-2.41,2.35-5.6-.33c-4.29-3.6-4.64-9.29-1.67-12.51,2.11-2.28,7.25-2.24,9.56,1.55,0,0,7.16,1.74,17.54-1.78C139.31,144.15,142.92,139.32,146.42,131.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.55,155.26h0l.35-8.25,5.26.23-.13,3A5.26,5.26,0,0,1,110.55,155.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.26,152.29a2,2,0,1,1-2-2A2,2,0,0,1,132.26,152.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,146.66l-4.51-1.81a2.34,2.34,0,0,1,3.08-1.41A2.55,2.55,0,0,1,148.87,146.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7,162.92l5.37,2.51a2.85,2.85,0,0,1-3.85,1.5A3.12,3.12,0,0,1,129.7,162.92Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,144.09l-4.89,2.41a2.61,2.61,0,0,1,1.14-3.62A2.86,2.86,0,0,1,131.07,144.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.26,152.29a2,2,0,1,1-2-2A2,2,0,0,1,147.26,152.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.75 149.34 136.67 161.34 143.54 160.22 137.75 149.34",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81,174.53c-6-2-12.35-5.56-13.79-9.74a10.14,10.14,0,0,0,3,6.79c3,2.79,10.48,5.93,10.48,5.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,140.57a12.65,12.65,0,0,0,.56,5.7,4,4,0,0,1-2.61.71,7.65,7.65,0,0,1-.49-6A4,4,0,0,1,111.78,140.57Z",
    style: {
      fill: "#D175F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.09,333.18l-7.41,4.28A5.1,5.1,0,0,1,88,333.05V293l4.64,2.67v37.42a.4.4,0,0,0,.23.39.43.43,0,0,0,.46,0l4.84-2.8C99.82,331.5,101.46,332.35,103.09,333.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72,344.52l-10.41,6a5.1,5.1,0,0,1-7.65-4.41V306l4.64,2.57v37.52a.45.45,0,0,0,.23.39.43.43,0,0,0,.46,0l7-4,2,.81A35.72,35.72,0,0,0,128.72,344.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.38,281.66,190,262.94c-6.66-3.85-17.46-3.85-24.12,0l-17.37,10c-6.66,3.85-17.46,3.85-24.12,0l-19-10.9c-6.66-3.85-17.46-3.85-24.12,0l-6.06,3.49c-3.31,1.92-5,4.43-5,6.94,0,1,0,5.1,0,6.12,0,2.53,1.65,5.05,5,7l75.45,43.55c6.66,3.85,17.46,3.86,24.12,0l47.55-27.45c3.33-1.92,5-4.44,5-7v-6.09C227.38,286.12,225.72,283.6,222.38,281.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.26,279.49l75.45,43.56c6.66,3.85,17.46,3.85,24.12,0l47.55-27.45c6.66-3.84,6.66-10.08,0-13.94L190,262.94c-6.66-3.85-17.46-3.85-24.12,0l-17.37,10c-6.66,3.85-17.46,3.85-24.12,0l-19-10.9c-6.66-3.85-17.46-3.85-24.12,0l-6.06,3.49C68.6,269.4,68.6,275.64,75.26,279.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exam--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134,288.1l44,25.38a2.69,2.69,0,0,0,2.47,0l32.35-18.67a.76.76,0,0,0,0-1.43l-44-25.38a2.75,2.75,0,0,0-2.47,0L134,286.68A.75.75,0,0,0,134,288.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134,291.14l44,25.37a2.69,2.69,0,0,0,2.47,0l32.35-18.67a.76.76,0,0,0,0-1.43l-44-25.38a2.75,2.75,0,0,0-2.47,0L134,289.71A.76.76,0,0,0,134,291.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M134,289.3l44,25.37a2.69,2.69,0,0,0,2.47,0L212.73,296a.76.76,0,0,0,0-1.43l-44-25.38a2.75,2.75,0,0,0-2.47,0L134,287.87A.76.76,0,0,0,134,289.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,312.41l31.6-18.24-43.28-25a2.75,2.75,0,0,0-2.47,0l-31.69,18.29,43.18,24.93A2.9,2.9,0,0,0,180.45,312.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,285.9l44,25.38a2.75,2.75,0,0,0,2.47,0l32.35-18.68a.76.76,0,0,0,0-1.43l-44-25.37a2.69,2.69,0,0,0-2.47,0L134,284.47A.76.76,0,0,0,134,285.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.81,292.6a.4.4,0,0,1-.22,0,.41.41,0,0,1-.23,0l-.89-.51c-.06,0-.09-.08-.09-.13s0-.09.09-.13l4-2.29a.48.48,0,0,1,.22-.05.56.56,0,0,1,.23.05l5.39,3.12a.14.14,0,0,1,.1.13s0,.09-.1.13l-3.89,2.25a.51.51,0,0,1-.22.05.52.52,0,0,1-.23-.05l-.89-.51c-.06,0-.09-.08-.09-.13a.15.15,0,0,1,.09-.13l2.58-1.49-.91-.52-2.39,1.38a.48.48,0,0,1-.22.05.52.52,0,0,1-.23-.05l-.88-.51c-.06,0-.09-.08-.09-.13A.15.15,0,0,1,198,293l2.39-1.38-.94-.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,294.86l-.43-1.48a.4.4,0,0,1,0-.15s.06-.1.18-.16l1.27-.73a.35.35,0,0,1,.36,0l0,0,0,0,.77,2.68,4.45.43a.23.23,0,0,1,.11,0s.08.06.08.11,0,.07-.08.1l-1.26.73a.68.68,0,0,1-.32.09h-.24l-2.42-.23.43,1.38a1.13,1.13,0,0,1,0,.14c0,.06,0,.12-.16.19l-1.28.73a.35.35,0,0,1-.18.05.48.48,0,0,1-.19-.05.11.11,0,0,1-.06-.07l-.78-2.59-4.58-.43-.08,0,0,0a.12.12,0,0,1-.07-.11s0-.07.07-.1l1.27-.73a.56.56,0,0,1,.29-.1,1.07,1.07,0,0,1,.25,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.1,301.11a.69.69,0,0,1-.34.09,1.35,1.35,0,0,1-.31,0l-7.09-2a.45.45,0,0,1-.15-.06.1.1,0,0,1-.08-.1.13.13,0,0,1,.07-.11l1.06-.61a.66.66,0,0,1,.53-.06l.93.26,2.22-1.28-.46-.54a.17.17,0,0,1,0-.13c0-.05.06-.11.17-.18l1.05-.6a.38.38,0,0,1,.19,0,.35.35,0,0,1,.18,0,.19.19,0,0,1,.09.09l3.45,4.09a.28.28,0,0,1,.06.18c0,.07-.05.13-.16.2Zm-2.3-2.89-1.35.78,2.68.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,301.67l.25,0,2.16.34-2.77-1.6a.15.15,0,0,1-.09-.13c0-.05,0-.09.09-.13l1.1-.63a.48.48,0,0,1,.22-.05.52.52,0,0,1,.23.05l5.4,3.12a.15.15,0,0,1,.09.13s0,.09-.09.13l-1,.56a.72.72,0,0,1-.34.09l-.25,0-3.66-.55,1,2.12a.37.37,0,0,1,0,.14c0,.07,0,.13-.16.2l-1,.56a.48.48,0,0,1-.22.05.52.52,0,0,1-.23-.05l-5.4-3.12c-.06,0-.09-.08-.09-.13a.15.15,0,0,1,.09-.13l1.1-.63a.38.38,0,0,1,.22-.06.52.52,0,0,1,.23.05l2.77,1.6-.6-1.25a.59.59,0,0,1,0-.14c0-.06,0-.11.12-.16l.54-.3A.5.5,0,0,1,181.38,301.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163,287.84c0,.08.1.08.11,0a.54.54,0,0,1,.56-.52,2.35,2.35,0,0,1,.65,0s.06,0,.07-.05a3.68,3.68,0,0,1,.18-.59c.14.11.33.23.46.05s0-.84.4-.48c0,0,.07,0,.1,0,.21-.33.44-.35.61-.14a1.69,1.69,0,0,0,.17.33c.06.08.12,0,.1-.1a1.52,1.52,0,0,0-.09-.28,1,1,0,0,1,.18-.77c.36-.25.78.35.84.64h0v0c0,.13.17.06.15,0a.06.06,0,0,0,0,0,1.38,1.38,0,0,1,.12-.85c.2-.33.44-.17.66.08.06.08.11,0,.11-.08,0-.41.31-1,.69-.49.05.06.12,0,.13,0l.12-.47a1.59,1.59,0,0,1,.1-.33c0-.17.07-.19.17-.06s.24.31.43.29.29-.39.27-.64c.16.08.35.16.49.06s.19-.33.22-.51c.12.12.27.23.43.13a1,1,0,0,0,.25-.59.72.72,0,0,1,.43.36c0,.06.09,0,.09-.06,0-.19,0-.53,0-.7.2-.35.63.26.72.48s.17.09.17,0c0-.36-.12-1.45.45-1.41a.74.74,0,0,1,.27.1,1.25,1.25,0,0,0,.72,1.52.07.07,0,0,0,.1,0,1.65,1.65,0,0,0-.59-1.58.69.69,0,0,1,.16-.22c.2-.19.48-.07.65-.28s0-.15.22-.27.22-.08.37.06a.72.72,0,0,1,.18.21c.05.07.12,0,.12-.06s0-.48.22-.53.36.13.46.23.11,0,.13-.05a2.89,2.89,0,0,0,0-.29.68.68,0,0,1,0-.2c0-.16.29-.43.42,0,0,.12.16.08.16,0a1.13,1.13,0,0,1,.3-.84.63.63,0,0,1,.4-.21h0a.48.48,0,0,0-.05.18c0,.21.09.55.32.61a.36.36,0,0,0,.41-.31.55.55,0,0,0-.31-.61l0,0a2.23,2.23,0,0,1,.47-.22,1.86,1.86,0,0,0,.41-.17c.05,0,.09-.17.13-.19.37-.2.19.05.37,0a.57.57,0,0,0,.58-.47c.3.3.56-.16.66-.5.13.19.29.48.5.53s.43-.15.57-.28,0,0,0,0c-.2.15-.41.33-.65.15a2.41,2.41,0,0,1-.41-.54s-.06,0-.07,0c-.05.23-.29.86-.59.44,0,0-.08,0-.09,0-.08.37-.26.47-.61.38-.15,0-.18-.06-.31,0s-.12.17-.22.24l-.18.06a2.86,2.86,0,0,0-.48.2,1.07,1.07,0,0,0-.28.19c-.52-.12-.91.44-1,1a.31.31,0,0,0-.45,0c-.18.14-.16.41-.18.64-.16-.13-.37-.26-.56-.16a.63.63,0,0,0-.24.51c-.19-.23-.49-.42-.72-.16s.18.17-.37.37c-.06,0-.14,0-.22,0a.94.94,0,0,0-.36.38l0,.06a.71.71,0,0,0-.21-.11c-.76-.33-.82.61-.8,1.24-.16-.24-.39-.48-.62-.46s-.3.54-.24.88a.89.89,0,0,0-.42-.28s-.06,0-.07,0,0,.3-.09.42c-.12.3-.33.2-.5,0s-.06,0-.07,0,0,.46-.22.53-.35-.11-.46-.19-.1,0-.1.07c0,.22.07.69-.33.48-.13-.07-.21-.23-.35-.3a.07.07,0,0,0-.09,0,2.85,2.85,0,0,0-.29.94c-.41-.45-.81.06-.85.57-.2-.22-.48-.39-.73-.11a1,1,0,0,0-.22.68c-.21-.32-.54-.59-.88-.44a.71.71,0,0,0-.34.81l-.08,0c-.28-.08-.44.12-.53.34l-.21-.16h-.06a.61.61,0,0,0-.21.39.64.64,0,0,1,0,.24c-.1.18-.24,0-.35-.1a.08.08,0,0,0-.1,0c-.19.19-.12.36-.19.59s0,.13-.26.07a1.15,1.15,0,0,0-.37-.06C163.14,287,162.94,287.34,163,287.84Zm15.47-9c0,.13-.11.3-.25.26s-.22-.37-.11-.56C178.28,278.56,178.47,278.66,178.48,278.82Zm-3.95,3.52a1,1,0,0,1-.54-1.13A1.55,1.55,0,0,1,174.53,282.34Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M174.1,276.23a.75.75,0,0,0,.47-.19,5.65,5.65,0,0,1,.6.57c.07.09.12,0,.12-.09a.78.78,0,0,1,.23-.54c.13-.13.23-.1.39-.07s.25-.06.25-.2c.24.1.37-.16.44-.39a.29.29,0,0,0,.37.06.88.88,0,0,0,.27-.43c.2.13.3.52.59.45s.43-.4.47-.62c0-.06,0-.07-.06,0-.05.21-.3.61-.55.49s-.25-.36-.45-.47c0,0,0,0-.05,0-.12.28-.26.63-.58.32,0,0-.07,0-.08,0-.05.2-.15.52-.4.34-.06,0-.09.05-.09.09,0,.22-.15.11-.27.09a.34.34,0,0,0-.29.08,1,1,0,0,0-.32.55c-.11-.11-.23-.2-.34-.3l-.14-.13,0-.08a.49.49,0,0,0-.36-.61s-.06,0-.08.05a.64.64,0,0,0,.17.64c-.11.07-.25.08-.36.15S174,276.24,174.1,276.23Zm.29-.8a.25.25,0,0,1,.17.34A.61.61,0,0,1,174.39,275.43Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.41,289.55a.78.78,0,0,0,.48-.19,6.82,6.82,0,0,1,.6.57c.06.08.12,0,.11-.09a.76.76,0,0,1,.23-.54c.14-.13.23-.1.39-.07s.25-.06.26-.2c.24.09.36-.16.44-.39a.29.29,0,0,0,.37.06.94.94,0,0,0,.27-.44c.19.14.29.52.59.46s.42-.4.47-.62c0-.06-.05-.07-.06,0-.05.21-.3.61-.56.49s-.24-.37-.44-.47c0,0-.05,0-.06,0-.11.28-.26.62-.58.32,0,0-.07,0-.07,0-.06.2-.15.52-.41.34-.06,0-.09,0-.08.09,0,.22-.15.11-.28.09a.32.32,0,0,0-.28.08.87.87,0,0,0-.33.55c-.1-.11-.22-.21-.33-.31l-.14-.13a.14.14,0,0,0,0-.07.5.5,0,0,0-.36-.62.07.07,0,0,0-.07.06.62.62,0,0,0,.17.64c-.12.07-.26.08-.37.15S158.33,289.56,158.41,289.55Zm.3-.81a.27.27,0,0,1,.17.35A.55.55,0,0,1,158.71,288.74Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.89,279.75s0,0,0,0,0-.27.14-.3.25.06.34.12.06,0,.06-.07,0-.31.11-.36.27.15.33.22.1,0,.1-.06.09-.64.35-.6a.3.3,0,0,1,.16.08.79.79,0,0,0,.3.71c.07,0,.1,0,.11-.08a1.2,1.2,0,0,0-.26-.78.6.6,0,0,1,.2-.41c.15-.11.28,0,.44,0a.21.21,0,0,0,.17-.19c.21.13.34-.08.43-.28.26.2.47,0,.53-.29a.66.66,0,0,0,.39.15c.23,0,.19-.27.16-.43s-.08,0-.07,0c0,.35-.38.09-.5,0s-.13,0-.13.07c0,.25-.15.48-.38.27,0,0-.07,0-.08,0s-.15.46-.35.27c0,0-.08,0-.09.06,0,.31-.24.11-.44.14a.51.51,0,0,0-.36.38s0,.09,0,.14a.43.43,0,0,0-.24-.1c-.35,0-.4.39-.41.69-.1-.12-.23-.24-.35-.17s-.15.28-.16.44c-.13-.07-.3-.16-.43-.07S169.85,279.62,169.89,279.75Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.49,279.92s0,0,0,0v0h0l0,0h.13l.09.05h0l0,0a.11.11,0,0,0,0-.08.27.27,0,0,0-.21-.05.23.23,0,0,0-.14.15A.06.06,0,0,0,169.49,279.92Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M168.92,280.54s0,0,0,0a.44.44,0,0,1,.13-.35.71.71,0,0,1,.32-.1l.28-.08s0-.13,0-.11-.31.07-.47.12a.3.3,0,0,0-.25.25A.67.67,0,0,0,168.92,280.54Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M161.4,284.56s.07,0,.08,0c.12-.35.4-.32.58,0,0,.06.07,0,.07-.06a1.53,1.53,0,0,1,.16-.81c.18-.27.3.06.5.05s.25-.24.26-.43c.18.11.34,0,.42-.23.21.18.37.05.46-.2.11.09.26.26.36.23s.22-1.08.53-.47c0,0,0,.05.05.05a.13.13,0,0,0,0,.11.41.41,0,0,0,.68-.2c.15-.34.25-1.56.79-.79,0,.06.11,0,.11-.05,0-.26,0-.61.33-.31,0,.05.1,0,.1-.06s0-.62.29-.42a.82.82,0,0,1,.28.46c0,.08.1,0,.09-.06a1.3,1.3,0,0,1,.19-.92c0-.05,0-.14-.06-.07a1.52,1.52,0,0,0-.25.7c-.1-.19-.25-.37-.42-.34s-.23.27-.24.46c-.32-.26-.41,0-.43.35-.21-.22-.45-.28-.66,0a1.83,1.83,0,0,0-.15.51.6.6,0,0,0-.16-.33c-.33-.3-.53.19-.59.55-.12-.14-.27-.22-.41,0s-.13.53-.18.53-.27-.22-.32-.24-.09,0-.1,0c0,.21-.12.25-.34.14a.07.07,0,0,0-.12,0c0,.18-.1.24-.32.19-.05-.07-.14,0-.14.05a.74.74,0,0,1,0,.3c-.11.15-.21,0-.31,0a.28.28,0,0,0-.34.12,1.32,1.32,0,0,0-.18.86c-.21-.29-.54-.31-.63.06a3.67,3.67,0,0,1-.85-1.38c0-.1-.12,0-.12.05C160.48,283.68,161.06,284.08,161.4,284.56Zm3.75-2.62c.25-.2.27.29.19.43a.34.34,0,0,1-.39.19v0A.77.77,0,0,1,165.15,281.94Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M167.55,276a4.17,4.17,0,0,0,1,1.86s.13.07.16,0,0-.79.23-.88.32.31.49.41a.07.07,0,0,0,.1,0c.14-.27.1-.66.27-.92.07.1.16.19.27.13s.13-.23.15-.37c.23.16.39,0,.47-.29.26.25.44.07.58-.24a.52.52,0,0,0,.35.23.07.07,0,0,0,.07,0,3.31,3.31,0,0,0,.12-.45c.1-.39.33,0,.42.17s.1.07.13,0a3,3,0,0,0,.12-.58.59.59,0,0,1,.05-.19.27.27,0,0,1,.35-.07c.11.05.17.27.2.38s.14.09.14,0c0-.35-.08-1,.3-1.2a.39.39,0,0,1,.26,0,.71.71,0,0,0-.09.55c.1.35.43.27.47-.06a.8.8,0,0,0-.15-.52,1.36,1.36,0,0,1,.5-.42c.07,0,0-.22,0-.18a1.76,1.76,0,0,0-.58.46.38.38,0,0,0-.43-.06c-.34.17-.39.62-.4,1-.11-.17-.27-.32-.47-.24s-.27.53-.32.83c-.11-.19-.27-.42-.47-.29s-.13.24-.16.35,0,.26-.06.29-.25-.18-.29-.22-.09,0-.11,0c-.1.23-.23.53-.49.21a.07.07,0,0,0-.12,0c0,.12-.09.53-.36.25a.07.07,0,0,0-.12,0c0,.07-.06.5-.23.23,0,0-.08-.07-.12,0-.24.25-.2.64-.32.95-.18-.17-.25-.52-.55-.4s-.3.51-.33.82a5.18,5.18,0,0,1-.8-1.57C167.68,275.77,167.51,275.82,167.55,276Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.13,279.9a.32.32,0,0,0,.18-.31c.11.1.23.26.38.17a.36.36,0,0,0,.13-.28c.12.12.26.2.43.07s.12-.27.13-.42a.25.25,0,0,0,.14.11c.09,0,.15-.07.19-.15a2.54,2.54,0,0,0,.15-.49,1.2,1.2,0,0,0,.5.4c.3.09.37-.3.39-.51s-.13-.18-.14,0-.07.44-.29.32a2,2,0,0,1-.45-.41.06.06,0,0,0-.11,0c0,.15-.06.3-.11.45s0,.17-.1.2-.12-.1-.15-.15-.09,0-.1,0,0,.29-.05.41a.22.22,0,0,1-.26.1c-.09,0-.14-.12-.2-.2s-.1,0-.09.1,0,.38-.14.31-.18-.19-.29-.26-.07.07-.07.1a.52.52,0,0,1-.09.36S164.09,279.91,164.13,279.9Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M154.61,292.42a.31.31,0,0,0,.18-.3c.11.1.23.26.37.17a.36.36,0,0,0,.13-.28c.12.12.27.2.44.06s.12-.26.13-.41a.23.23,0,0,0,.13.11c.1,0,.16-.08.2-.15a2.11,2.11,0,0,0,.14-.49,1.4,1.4,0,0,0,.51.4c.3.09.37-.3.39-.51s-.13-.18-.15,0-.06.43-.29.31a2.12,2.12,0,0,1-.45-.4s-.09,0-.1,0-.07.3-.11.45,0,.17-.1.19-.13-.1-.15-.14-.09,0-.11,0,0,.29-.05.41a.2.2,0,0,1-.25.1c-.09,0-.15-.13-.2-.2s-.11,0-.1.09,0,.39-.14.32-.18-.2-.28-.26-.07.07-.07.1a.57.57,0,0,1-.09.36S154.57,292.44,154.61,292.42Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.75,284.93c0,.05.09,0,.09-.05a2.72,2.72,0,0,1,.08-.8.37.37,0,0,1,.29-.31c.16,0,.25.12.39.18.39.18.52-.34.54-.66.14.06.27,0,.32-.1.24.21.41,0,.46-.31.12.12.24.24.41.07s.13-.37.15-.57c.17.17.35.36.59.19s.21-.46.24-.71a2.85,2.85,0,0,1,.37.23s0,0,0,0a1.86,1.86,0,0,0,.1-.2.3.3,0,0,1,.16-.23,1,1,0,0,1,.33.25.06.06,0,0,0,.1,0c.06-.11.08-.24.14-.36s.23-.17.42,0,.12,0,.14-.07a3.4,3.4,0,0,1,.06-.46c.15-.45.56,0,.66.25s.13,0,.13-.05c0-.25-.16-.87.13-1,.06,0,.05-.18,0-.16-.29.09-.28.49-.26.81-.16-.21-.38-.4-.62-.29s-.23.39-.25.62c-.12-.1-.28-.18-.42-.07a.94.94,0,0,0-.21.54,2.22,2.22,0,0,0-.39-.23s0,0,0,0a1.94,1.94,0,0,0-.13.3c-.12.24-.25,0-.45-.05,0,0,0,0-.06.05,0,.2,0,.61-.25.69s-.38-.17-.51-.29-.09,0-.11,0,0,.22,0,.31-.22.27-.31.24l-.12-.11c-.06-.06-.1.06-.09.1,0,.21-.07.3-.33.27-.05-.07-.1,0-.1.07s-.14.17-.25.06-.08,0-.09.05a2.14,2.14,0,0,1-.08.44.28.28,0,0,1-.32.22s-.13-.11-.17-.14a.41.41,0,0,0-.51,0c-.26.22-.24.68-.22,1a3,3,0,0,1-.79-1.31c0-.1-.1-.06-.1,0C155.8,284,156.44,284.49,156.75,284.93Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "175.75 300.83 171.84 303.11 168.88 301.39 172.78 299.12 175.75 300.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,300.85l-2.73-1.57-3.58,2.09,2.72,1.57Zm-2.79-1.8.12,0a.55.55,0,0,1,.21,0l3,1.71s0,.05,0,.08l-3.9,2.28a.64.64,0,0,1-.23.06.4.4,0,0,1-.2,0l-3-1.72s0-.05,0-.08l3.91-2.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,287.16l-.22-.12a.54.54,0,0,0-.49,0l-21.08,12.17c-.15.09-.18.21-.07.28l.22.12a.54.54,0,0,0,.49,0l21.08-12.17C199.35,287.35,199.38,287.23,199.27,287.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,286.41l-.21-.12a.56.56,0,0,0-.5,0L176.19,298.5c-.16.09-.19.22-.07.28l.21.13a.57.57,0,0,0,.49,0L197.9,286.7C198.06,286.61,198.09,286.48,198,286.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.68,285.67l-.21-.13a.58.58,0,0,0-.49,0L174.9,297.75c-.16.09-.19.22-.07.29l.21.12a.54.54,0,0,0,.49,0L196.61,286C196.77,285.86,196.8,285.74,196.68,285.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.44 300.69 173.27 300.69 173.27 301.14 172.23 301.14 172.23 303.64 171.44 303.64 171.44 300.69",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.31 297.69 166.41 299.97 163.44 298.25 167.34 295.98 170.31 297.69",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,297.71l-2.72-1.57-3.59,2.09,2.72,1.57Zm-2.79-1.8.12,0a.55.55,0,0,1,.21,0l3,1.71s0,.05,0,.08L166.61,300a.64.64,0,0,1-.22.06.42.42,0,0,1-.21,0l-3-1.72s0-.05,0-.08l3.9-2.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,284l-.22-.12a.54.54,0,0,0-.49,0L172,296.11c-.15.09-.18.21-.07.28l.22.12a.54.54,0,0,0,.49,0l21.08-12.17C193.91,284.22,193.94,284.09,193.83,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.53,283.27l-.21-.12a.54.54,0,0,0-.49,0l-21.08,12.17c-.16.09-.19.22-.07.28l.21.13a.57.57,0,0,0,.49,0l21.08-12.17C192.62,283.47,192.65,283.34,192.53,283.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.24,282.53l-.21-.12a.54.54,0,0,0-.49,0l-21.08,12.16c-.16.09-.19.22-.07.29l.21.12a.56.56,0,0,0,.5,0l21.07-12.17C191.33,282.72,191.36,282.6,191.24,282.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.87 294.55 160.97 296.83 158 295.12 161.91 292.84 164.87 294.55",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,294.57,161.87,293l-3.59,2.09,2.73,1.57Zm-2.79-1.79.13,0a.53.53,0,0,1,.2,0l3,1.71s0,.05,0,.08l-3.91,2.28a.64.64,0,0,1-.22.06.42.42,0,0,1-.21,0l-3-1.72s0-.05,0-.08l3.9-2.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.57 294.4 162.39 294.4 162.39 294.86 161.35 294.86 161.35 297.36 160.57 297.36 160.57 294.4",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.39,280.88l-.22-.12a.54.54,0,0,0-.49,0L166.61,293c-.16.09-.19.21-.08.28l.22.13a.58.58,0,0,0,.49-.05l21.08-12.16C188.47,281.08,188.51,281,188.39,280.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,280.13l-.21-.12a.54.54,0,0,0-.49,0l-21.08,12.17c-.16.09-.19.22-.07.28l.21.13a.6.6,0,0,0,.5,0L187,280.42C187.18,280.33,187.21,280.2,187.09,280.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8,279.39l-.21-.12a.54.54,0,0,0-.49,0L164,291.47c-.15.09-.19.22-.07.29l.22.12a.54.54,0,0,0,.49,0l21.07-12.17C185.89,279.58,185.92,279.46,185.8,279.39Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.48,279.78l2.8,6.48a.22.22,0,0,1-.3.28l-6.2-3.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,286.54a.22.22,0,0,0,.3-.28l-.54-1.26h0a1.19,1.19,0,0,1-1,.78l-.12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81,261l.44.49.52.58,19,21a3.14,3.14,0,0,0,2.2-.68,3.23,3.23,0,0,0,1.5-2.61l-19-21-1-1.12C133.09,258.43,129.44,261.75,128.81,261Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.47,262.84l1,1.08c.28.33,1.13-.08,2-.71,1.11-.83,2.06-2.2,1.7-2.63l-.72-.8-.27-.28c.37.43-.58,1.8-1.69,2.64-.8.6-1.62,1-1.92.73h0S130.48,262.86,130.47,262.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.72,263.11c.63.75,4.29-2.59,3.65-3.34l-1-1.08c.64.75-3,4.09-3.65,3.34Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81,261l1,1.07c.62.75,4.17-2.45,3.72-3.27l0-.05-1-1.07C133.09,258.43,129.44,261.75,128.81,261Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,286.52l.06-.26-3.75-4.32-20.11-22.22c.07-.07.07-.11,0-.13-1,1-2.27,1.83-2.62,1.4l.44.49.52.58,19,21h0l6.2,3.46A.23.23,0,0,0,155.22,286.52Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.71,256.45l4.1,4.54c.27.33,1.11-.07,1.94-.69,1.11-.83,2.08-2.2,1.72-2.63h0l-4.11-4.55c-.82-.91-2.86.53-3.61,1.91A1.25,1.25,0,0,0,124.71,256.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,256.41a3.85,3.85,0,0,0,2.1-2.67.89.89,0,0,0-.28-.76c-.89-.62-2.75.74-3.46,2a1.26,1.26,0,0,0,0,1.41C125,256.77,125.64,256.79,126.39,256.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,265.75a4.85,4.85,0,0,1,3.76,2.06c1.08,1.2,2.94,1.87,2.91,2.57s-1.22,1.4-1.22,1.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.53,284.58a12.55,12.55,0,0,0,7.69-1.81c.56-.37,1.1-.78,1.66-1.16a3.86,3.86,0,0,1,1.41-.79c.43-.09.86-.12,1.28-.23a3.37,3.37,0,0,0,2.26-2,3.23,3.23,0,0,1,.24-.58.78.78,0,0,1,.47-.39,1.14,1.14,0,0,1,.65.11,9.32,9.32,0,0,0,2.33.8,4.52,4.52,0,0,0,1.83-.08c.45-.13,1.36-.65.83-1.22-.71-.75-1.38-1.54-2-2.06-3.08-2.69-6-3.86-9.77-5.32-1.76-.68-4.29-1.4-6-2-.76-.27-1.54-.66-2.32-1l-1-1.07a5.23,5.23,0,0,0-2.32.14c-1.21.32-2.63,1-3.85,1.23-3.08.66-8-.68-11.8-1.94C107.62,262.72,88,254.07,88,254.07l5-36.68c4.24-7.44,1.43-26.55-2.14-30.49-3.43,1.15-9.45,2.27-13.67,7.21-2.92,3.42-4.56,8.79-5.65,16.72-1.52,11-3.62,36.24-3.76,47.36s1.34,11.31,10.91,14.38c1.36.44,2.75.81,4.14,1.16,5.39,1.41,10.84,2.62,16.29,3.79,6.46,1.4,12.93,2.73,19.42,4C121.35,282,130.41,284.38,133.53,284.58Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88,254.07a16.7,16.7,0,0,0-8.39-.48,11.25,11.25,0,0,1,8.68-1.66Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--finger--inject-12",
    d: "M192.37,264.31a18.18,18.18,0,0,0,5.67,8.35,24.91,24.91,0,0,1,5.16,5.69c1.2,1.61,2.85.17,2.23-2.58-.49-2.12-2.69-5-3.12-7.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,95.59l-3.8-7.16,3.06-8.83V74.19l-9.37,5.41V85l4,7a.48.48,0,0,0,.27.24h0Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,95.59l-3.8-7.16,3.06-8.83V74.19l-9.37,5.41V85l4,7a.48.48,0,0,0,.27.24h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42,39a6.22,6.22,0,0,0-2.81-4.87l-2.28-1.32a6.19,6.19,0,0,0-5.62,0l-53,30.6a6.23,6.23,0,0,0-2.81,4.87V95.64a6.23,6.23,0,0,0,2.81,4.87L89,101.83a6.23,6.23,0,0,0,5.61,0l23.09-13.42,4,7a.6.6,0,0,0,1.09-.1L127.08,83l20.53-11.79a6.2,6.2,0,0,0,2.81-4.86Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.93,95.64a6.23,6.23,0,0,0,2.81,4.87L89,101.83a6.23,6.23,0,0,0,5.13.22c-1.32.5-2.33-.24-2.33-1.84V72.81A5.76,5.76,0,0,1,92.66,70l-7.91-4.56a5.71,5.71,0,0,0-.82,2.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.33,38.17c-.33-1.2-1.42-1.58-2.71-.83L94.64,68a5.66,5.66,0,0,0-2,2.1l-7.9-4.56a5.74,5.74,0,0,1,2-2.1l53-30.61a6.25,6.25,0,0,1,5.62,0l2.3,1.32A6.23,6.23,0,0,1,150.33,38.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,73.25a8.29,8.29,0,0,0-3.75,6.49c0,2.4,1.68,3.36,3.75,2.17a8.29,8.29,0,0,0,3.75-6.49C111.06,73,109.38,72.06,107.31,73.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13,65.26a8.28,8.28,0,0,0-3.75,6.49c0,2.39,1.68,3.36,3.75,2.16a8.28,8.28,0,0,0,3.75-6.49C124.88,65,123.2,64.06,121.13,65.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,57.26a8.31,8.31,0,0,0-3.75,6.5c0,2.39,1.68,3.35,3.75,2.16a8.28,8.28,0,0,0,3.74-6.49C138.69,57,137,56.07,135,57.26Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.2,27.59a19.9,19.9,0,0,1,5.46-1.37,15.18,15.18,0,0,1,5.33.36,12,12,0,0,1,4.58,2.28,10.67,10.67,0,0,1,3.17,4.4,10.8,10.8,0,0,1,.89,4.2,13.05,13.05,0,0,1-.59,3.73,22.53,22.53,0,0,1-1.41,3.4c-.57,1.08-1.11,2.11-1.61,3.08a17.48,17.48,0,0,0-1.19,2.89,4.91,4.91,0,0,0-.1,2.73,2.31,2.31,0,0,1-.08,1.28,1.34,1.34,0,0,1-.83.86l-4.28,1.75a1.65,1.65,0,0,1-1.29,0,1.34,1.34,0,0,1-.85-.9,10.69,10.69,0,0,1-.65-4.24,15.17,15.17,0,0,1,.76-3.79,21.27,21.27,0,0,1,1.51-3.4q.89-1.62,1.62-3.06a13.8,13.8,0,0,0,1.05-2.73,3.79,3.79,0,0,0-.15-2.47,4.59,4.59,0,0,0-3.23-2.79,8.32,8.32,0,0,0-5.36.57q-4.8,1.95-5.1,7.66a3.5,3.5,0,0,1-.21,1.17,1.59,1.59,0,0,1-.92.73l-4.57,1.86a1.36,1.36,0,0,1-1,0,1.25,1.25,0,0,1-.73-.76,9.39,9.39,0,0,1-.43-4.52,14.62,14.62,0,0,1,1.59-5,18.05,18.05,0,0,1,3.45-4.6A15.9,15.9,0,0,1,251.2,27.59ZM266.48,58.7a1.66,1.66,0,0,1,2.14.91l2,5a1.65,1.65,0,0,1-.9,2.14l-4.85,2a1.58,1.58,0,0,1-1.26,0,1.54,1.54,0,0,1-.88-.89l-2-5a1.65,1.65,0,0,1,.9-2.14Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.43,26.27a13.44,13.44,0,0,1,3.67,1.28,10.69,10.69,0,0,1,2.95,2.22,8.45,8.45,0,0,1,1.78,3.05,7.32,7.32,0,0,1,.16,3.74,7.19,7.19,0,0,1-1.08,2.76,8.72,8.72,0,0,1-1.74,1.93,14.77,14.77,0,0,1-2.11,1.43L305,43.85a11.85,11.85,0,0,0-1.78,1.22,3.4,3.4,0,0,0-1.09,1.54,1.65,1.65,0,0,1-.53.71.94.94,0,0,1-.8.18l-3.14-.61a1.16,1.16,0,0,1-.74-.49.92.92,0,0,1-.15-.84A7.18,7.18,0,0,1,298,42.87,10.27,10.27,0,0,1,299.84,41,14.67,14.67,0,0,1,302,39.57c.75-.4,1.45-.78,2.09-1.16a9.47,9.47,0,0,0,1.64-1.17,2.6,2.6,0,0,0,.85-1.49,3.14,3.14,0,0,0-.81-2.83,5.74,5.74,0,0,0-3.31-1.7,5.51,5.51,0,0,0-5.84,2.49,2.37,2.37,0,0,1-.57.6,1.09,1.09,0,0,1-.81.08l-3.34-.66a1,1,0,0,1-.59-.37.91.91,0,0,1-.14-.71,6.55,6.55,0,0,1,1.47-2.78,10.36,10.36,0,0,1,2.8-2.28,12.52,12.52,0,0,1,3.73-1.34A11.11,11.11,0,0,1,303.43,26.27ZM300.49,50a1.07,1.07,0,0,1,.71.48,1.09,1.09,0,0,1,.18.85L300.67,55a1.09,1.09,0,0,1-.49.72,1.05,1.05,0,0,1-.84.17l-3.55-.69a1.11,1.11,0,0,1-.72-.48,1.13,1.13,0,0,1-.18-.85l.72-3.63a1.11,1.11,0,0,1,.48-.72,1.08,1.08,0,0,1,.85-.18Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M303.43,26.27a13.44,13.44,0,0,1,3.67,1.28,10.69,10.69,0,0,1,2.95,2.22,8.45,8.45,0,0,1,1.78,3.05,7.32,7.32,0,0,1,.16,3.74,7.19,7.19,0,0,1-1.08,2.76,8.72,8.72,0,0,1-1.74,1.93,14.77,14.77,0,0,1-2.11,1.43L305,43.85a11.85,11.85,0,0,0-1.78,1.22,3.4,3.4,0,0,0-1.09,1.54,1.65,1.65,0,0,1-.53.71.94.94,0,0,1-.8.18l-3.14-.61a1.16,1.16,0,0,1-.74-.49.92.92,0,0,1-.15-.84A7.18,7.18,0,0,1,298,42.87,10.27,10.27,0,0,1,299.84,41,14.67,14.67,0,0,1,302,39.57c.75-.4,1.45-.78,2.09-1.16a9.47,9.47,0,0,0,1.64-1.17,2.6,2.6,0,0,0,.85-1.49,3.14,3.14,0,0,0-.81-2.83,5.74,5.74,0,0,0-3.31-1.7,5.51,5.51,0,0,0-5.84,2.49,2.37,2.37,0,0,1-.57.6,1.09,1.09,0,0,1-.81.08l-3.34-.66a1,1,0,0,1-.59-.37.91.91,0,0,1-.14-.71,6.55,6.55,0,0,1,1.47-2.78,10.36,10.36,0,0,1,2.8-2.28,12.52,12.52,0,0,1,3.73-1.34A11.11,11.11,0,0,1,303.43,26.27ZM300.49,50a1.07,1.07,0,0,1,.71.48,1.09,1.09,0,0,1,.18.85L300.67,55a1.09,1.09,0,0,1-.49.72,1.05,1.05,0,0,1-.84.17l-3.55-.69a1.11,1.11,0,0,1-.72-.48,1.13,1.13,0,0,1-.18-.85l.72-3.63a1.11,1.11,0,0,1,.48-.72,1.08,1.08,0,0,1,.85-.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M249.45,92.62a1.27,1.27,0,0,1,.88-.53,1.31,1.31,0,0,1,1,.23l3.54,2.57a1.37,1.37,0,0,1,.3,1.88l-2.51,3.47a1.33,1.33,0,0,1-.88.53,1.3,1.3,0,0,1-1-.23L247.23,98a1.29,1.29,0,0,1-.53-.88,1.31,1.31,0,0,1,.23-1Zm-24.06-15a15.71,15.71,0,0,1,3.2-3.31,12.46,12.46,0,0,1,3.86-2.06,9.78,9.78,0,0,1,4.16-.39,8.6,8.6,0,0,1,4.1,1.68,8.82,8.82,0,0,1,2.44,2.54,10.49,10.49,0,0,1,1.2,2.84,17.7,17.7,0,0,1,.49,3c.07,1,.15,1.94.22,2.83a13.8,13.8,0,0,0,.42,2.52,4,4,0,0,0,1.11,2,2,2,0,0,1,.5.92,1.1,1.1,0,0,1-.21,1l-2.22,3.07a1.37,1.37,0,0,1-.89.55,1.13,1.13,0,0,1-1-.25,8.75,8.75,0,0,1-2.27-2.67,12.57,12.57,0,0,1-1.12-3,17.55,17.55,0,0,1-.42-3c-.05-1-.12-1.94-.2-2.82a11,11,0,0,0-.45-2.35A3.08,3.08,0,0,0,237.15,79a3.73,3.73,0,0,0-3.45-.54,6.76,6.76,0,0,0-3.47,2.7q-2.49,3.43-.24,7.53a2.75,2.75,0,0,1,.36.91,1.24,1.24,0,0,1-.32.9l-2.37,3.27a1.06,1.06,0,0,1-1.53.24,7.73,7.73,0,0,1-2.25-3,12.13,12.13,0,0,1-1-4.15,14.87,14.87,0,0,1,.41-4.68A13.05,13.05,0,0,1,225.39,77.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.45,92.62a1.27,1.27,0,0,1,.88-.53,1.31,1.31,0,0,1,1,.23l3.54,2.57a1.37,1.37,0,0,1,.3,1.88l-2.51,3.47a1.33,1.33,0,0,1-.88.53,1.3,1.3,0,0,1-1-.23L247.23,98a1.29,1.29,0,0,1-.53-.88,1.31,1.31,0,0,1,.23-1Zm-24.06-15a15.71,15.71,0,0,1,3.2-3.31,12.46,12.46,0,0,1,3.86-2.06,9.78,9.78,0,0,1,4.16-.39,8.6,8.6,0,0,1,4.1,1.68,8.82,8.82,0,0,1,2.44,2.54,10.49,10.49,0,0,1,1.2,2.84,17.7,17.7,0,0,1,.49,3c.07,1,.15,1.94.22,2.83a13.8,13.8,0,0,0,.42,2.52,4,4,0,0,0,1.11,2,2,2,0,0,1,.5.92,1.1,1.1,0,0,1-.21,1l-2.22,3.07a1.37,1.37,0,0,1-.89.55,1.13,1.13,0,0,1-1-.25,8.75,8.75,0,0,1-2.27-2.67,12.57,12.57,0,0,1-1.12-3,17.55,17.55,0,0,1-.42-3c-.05-1-.12-1.94-.2-2.82a11,11,0,0,0-.45-2.35A3.08,3.08,0,0,0,237.15,79a3.73,3.73,0,0,0-3.45-.54,6.76,6.76,0,0,0-3.47,2.7q-2.49,3.43-.24,7.53a2.75,2.75,0,0,1,.36.91,1.24,1.24,0,0,1-.32.9l-2.37,3.27a1.06,1.06,0,0,1-1.53.24,7.73,7.73,0,0,1-2.25-3,12.13,12.13,0,0,1-1-4.15,14.87,14.87,0,0,1,.41-4.68A13.05,13.05,0,0,1,225.39,77.62Z",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC13);
export default __webpack_public_path__ + "static/media/c13.00f047143415f1c66ef0ea9971679820.svg";
export { ForwardRef as ReactComponent };